import React, { useEffect, useState } from "react";
import { useFormik, FormikProvider, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { Table, Row, Col } from "react-bootstrap";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import Swal from "sweetalert2";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { generateManagementDeficienciesPdf } from "./PdfForChangeofManagement";
import { FaEye } from "react-icons/fa";
import { viewImage } from "../../CommonUtils/viewImage";

export default function ChangeOfManagement({ collCode, nocType, instName }) {
  const [isFinal, setIsFinal] = useState(false);
  const isEmptyFormValue = (value) => {
    if (Array.isArray(value)) {
      return value.length === 0;
    }

    if (value && typeof value === "object") {
      return Object.keys(value).length === 0;
    }

    return value === "" || value === null || value === undefined;
  };

  const getAccommodationKey = (row = {}) => {
    const nameKey = String(row?.particularName || row?.particular_name || "")
      .trim()
      .toLowerCase();
    if (nameKey) {
      return `name:${nameKey}`;
    }

    const codeKey = String(row?.particularCode || row?.particular_code || "").trim();
    if (codeKey) {
      return `code:${codeKey}`;
    }

    return "";
  };

  const mergeAccommodationRows = (existingRows = [], apiRows = []) => {
    if (!Array.isArray(apiRows) || apiRows.length === 0) {
      return existingRows;
    }

    if (!Array.isArray(existingRows) || existingRows.length === 0) {
      return apiRows;
    }

    const apiRowsByKey = new Map(apiRows.map((row) => [getAccommodationKey(row), row]).filter(([key]) => Boolean(key)));

    return existingRows.map((row, index) => {
      const rowKey = getAccommodationKey(row);
      const apiRow = (rowKey && apiRowsByKey.get(rowKey)) || apiRows[index] || {};

      return {
        ...row,
        sufficientAsPerNorms: isEmptyFormValue(row?.sufficientAsPerNorms) ? apiRow.sufficientAsPerNorms || apiRow.sufficient_as_per_norms || apiRow.sufficient_orms || "" : row.sufficientAsPerNorms,
        remarks: isEmptyFormValue(row?.remarks) ? apiRow.remarks || "" : row.remarks,
        particularName: row?.particularName || apiRow.particularName || apiRow.particular_name || "",
        particularCode: row?.particularCode || apiRow.particularCode || apiRow.particular_code || "",
      };
    });
  };

  const buildAccommodationRows = (baseRows = [], existingRows = []) => {
    const initialRows = Array.isArray(baseRows)
      ? baseRows.map((item) => ({
        particularCode: item.particular_code || "",
        particularName: item.particular_name || "",
        sufficientAsPerNorms: "",
        remarks: "",
      }))
      : [];

    return mergeAccommodationRows(initialRows, existingRows);
  };

  const mergeManagementScrutinyValues = (currentValues, mappedValues) => {
    const mergedValues = { ...currentValues };

    Object.entries(mappedValues).forEach(([key, incomingValue]) => {
      if (key === "deficiencies" || key === "accomodation") {
        return;
      }

      if (!isEmptyFormValue(incomingValue) && isEmptyFormValue(currentValues[key])) {
        mergedValues[key] = incomingValue;
      }
    });

    const mergedDeficiencies = Array.isArray(mappedValues.deficiencies) ? mappedValues.deficiencies.filter((item) => !isEmptyFormValue(item?.deficiences)) : [];
    if (mergedDeficiencies.length > 0 && (!Array.isArray(currentValues.deficiencies) || currentValues.deficiencies.every((item) => isEmptyFormValue(item?.deficiences)))) {
      mergedValues.deficiencies = mergedDeficiencies;
    }

    mergedValues.accomodation = mergeAccommodationRows(currentValues.accomodation, mappedValues.accomodation);

    return mergedValues;
  };

  // **********states**********
  const [societyName, setSocietyName] = useState([]);
  const [isBuildingSameAsExisting, setIsBuildingSameAsExisting] = useState(false);
  const [apiValues, setApiValues] = useState({});
  const [parking, setParking] = useState({});
  const [getAccomidation, setAccom] = useState([]);
  const [pgAcc, setpgAcc] = useState([]);
  const [getUgCourses, setUgCourse] = useState([]);
  const [pgCourses, setPgCourses] = useState([]);
  const [corpusFundInstall, setcorpusFundInstall] = useState([]);
  const [ugCorpusFunds, setUgCorpusFunds] = useState([]);
  const [pgBefore, setPGBEFORE] = useState([]);
  const [pgCorpusFunds, setPgCorpusFunds] = useState([]);
  const [nocdata, setNocdata] = useState([]);
  const [selectedFinalStatus, setSelectedFinalStatus] = useState("");
  const [instData, setInstData] = useState([]);
  const [landDetails, setLandDetails] = useState({});
  const [buildingDocs, setBuildingDocs] = useState([]);
  const [managementData, setManagementData] = useState([]);
  const [finalsubmit, setFinalSubmit] = useState("");
  const [leasedData, setLeasedData] = useState([]);

  const validationSchema = Yup.object().shape({
    // *********Society Basic Details Section 1********
    regCertHandingover: Yup.string().required("Required"),
    regCertTakingover: Yup.string().required("Required"),
    // regCertRemarks: Yup.string().required("Required"),

    byeLawsHandingover: Yup.string().required("Required"),
    byeLawsTakingover: Yup.string().required("Required"),
    // byeLawsRemarks: Yup.string().required("Required"),

    resolutionsHandingover: Yup.string().required("Required"),
    resolutionsTakingover: Yup.string().required("Required"),
    // resolutionsRemarks: Yup.string().required("Required"),

    resolutionValidHandingover: Yup.string().required("Required"),
    resolutionValidTakingover: Yup.string().required("Required"),
    // resolutionValidRemarks: Yup.string().required("Required"),

    commonMembersExists: Yup.string().required("Required"),
    // commonMembersRemarks: Yup.string().required("Required"),

    fixedAssetsTransfer: Yup.string().required("Required"),
    // fixedAssetsRemarks: Yup.string().required("Required"),

    // **********College Basic Details Section 2*********
    // collegeNameRemarks: Yup.string().required("Required"),
    // collegeAddressRemarks: Yup.string().required("Required"),
    // principalContactRemarks: Yup.string().required("Required"),
    // jnanabhumiCodeRemarks: Yup.string().required("Required"),
    // aisheCodeRemarks: Yup.string().required("Required"),
    // yearOfEstablishmentRemarks: Yup.string().required("Required"),
    // mandalNameRemarks: Yup.string().required("Required"),
    // districtNameRemarks: Yup.string().required("Required"),
    mandalStatus: Yup.string().required("Required"),
    // mandalStatusRemarks: Yup.string().required("Required"),
    permissionOrderUploaded: Yup.string().required("Required"),
    // permissionOrderRemarks: Yup.string().required("Required"),
    universityAffiliationUploaded: Yup.string().required("Required"),
    // universityAffiliationRemarks: Yup.string().required("Required"),
    lastEopUploaded: Yup.string().required("Required"),
    lastEopRemarks: Yup.string().required("Required"),
    // feeProofUploaded: Yup.string().required("Required"),
    feeProofRemarks: Yup.string().required("Required"),

    // *********** Own Land Section 3*********
    ownLandHandingover: Yup.string().required("Required"),

    // ownLandTakingover: Yup.string().when("ownLandHandingover", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    // }),

    // ownLandRemarks: Yup.string().required("Required"),

    landDeedProducedHandingover: Yup.string().required("Required"),
    // landDeedProducedRemarks: Yup.string().required("Required"),

    landInSocietyNameHandingover: Yup.string().required("Required"),
    // landInSocietyNameRemarks: Yup.string().required("Required"),

    landInSameMandalHandingover: Yup.string().required("Required"),
    // landInSameMandalRemarks: Yup.string().required("Required"),

    sketchPlanProducedHandingover: Yup.string().required("Required"),
    // sketchPlanProducedRemarks: Yup.string().required("Required"),

    propertyScheduleTallyHandingover: Yup.string().required("Required"),
    // propertyScheduleTallyRemarks: Yup.string().required("Required"),

    // *************** Building Details Section 4***************
    // 4.1
    buildingAddressSurveyExisting: Yup.string().required("Required"),
    buildingAddressTownExisting: Yup.string().required("Required"),
    // buildingAddressRemarks: Yup.string().required("Required"),

    // 4.2
    sameMandalExisting: Yup.string().required("Required"),
    // sameMandalRemarks: Yup.string().required("Required"),

    // 4.3
    permanentBuildingExisting: Yup.string().required("Required"),
    // permanentBuildingRemarks: Yup.string().required("Required"),

    // 4.4
    distanceRequirementExisting: Yup.string().required("Required"),
    // distanceRequirementRemarks: Yup.string().required("Required"),

    // 4.5
    buildingOwnershipExisting: Yup.string().required("Required"),
    // buildingOwnershipRemarks: Yup.string().required("Required"),

    // 4.6 - Leased (Conditional but required if ownership is Leased)
    leasedDocumentExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // leasedDocumentRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Leased",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    leaseRegisteredInSocietyExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // leaseRegisteredInSocietyRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Leased",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    leaseRegistrationYearExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // leaseRegistrationYearRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Leased",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    leaseValidityFromExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    leaseValidityToExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // leaseValidityRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Leased",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    yearsCompletedExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // yearsCompletedRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Leased",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    remainingLeaseYearsExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Leased",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // remainingLeaseRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Leased",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // 4.7 - Sale Deed (Conditional but required if ownership is Own)
    saleDeedUploadedExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Own",
      then: (schema) => schema.required("Required"),
    }),

    // saleDeedUploadedRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Own",
    //   then: (schema) => schema.required("Required"),
    // }),

    // 4.8
    saleDeedInSocietyExisting: Yup.string().when("buildingOwnershipExisting", {
      is: "Own",
      then: (schema) => schema.required("Required"),
    }),

    // saleDeedInSocietyRemarks: Yup.string().when("buildingOwnershipExisting", {
    //   is: "Own",
    //   then: (schema) => schema.required("Required"),
    // }),

    // 4.9
    planApprovedExisting: Yup.string().required("Required"),
    // planApprovedRemarks: Yup.string().required("Required"),

    // 4.10
    approvedPlanUploadedExisting: Yup.string().required("Required"),
    // approvedPlanUploadedRemarks: Yup.string().required("Required"),

    // 4.11
    carpetAreaExisting: Yup.string().required("Required"),
    // carpetAreaRemarks: Yup.string().required("Required"),

    // 4.12
    constructionPermissionExisting: Yup.string().required("Required"),
    // constructionPermissionRemarks: Yup.string().required("Required"),

    // 4.13
    sanitaryCertificateExisting: Yup.string().required("Required"),
    // sanitaryCertificateRemarks: Yup.string().required("Required"),

    // 4.14
    geoTaggedPhotosExisting: Yup.string().required("Required"),
    // geoTaggedPhotosRemarks: Yup.string().required("Required"),

    // 4.15
    otherInstitutionExisting: Yup.string().required("Required"),
    // otherInstitutionRemarks: Yup.string().required("Required"),

    // 4.16
    nocUploadedExisting: Yup.string().when("otherInstitutionExisting", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
    }),
    // nocUploadedRemarks: Yup.string().when("otherInstitutionExisting", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    // }),

    // 4.17
    annexureDetailsExisting: Yup.string().required("Required"),
    // annexureDetailsRemarks: Yup.string().required("Required"),

    // 4.19 Parking
    parkingAreaSamePremisesExisting: Yup.string().required("Required"),
    // parkingAreaSamePremisesRemarks: Yup.string().required("Required"),

    // ✅ Only required if  Yes in same premises
    parkingArea20PercentExisting: Yup.string().when("parkingAreaSamePremisesExisting", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // parkingArea20PercentRemarks: Yup.string().when("parkingAreaSamePremisesExisting", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // ✅ Only required if NOT in same premises
    parkingAreaWithin100mExisting: Yup.string().when("parkingAreaSamePremisesExisting", {
      is: "No",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // parkingAreaWithin100mRemarks: Yup.string().when("parkingAreaSamePremisesExisting", {
    //   is: "No",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    parkingAreaWithin100mDocUploaded: Yup.string().when("parkingAreaWithin100mExisting", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // parkingAreaWithin100mDocRemarks: Yup.string().when("parkingAreaWithin100mExisting", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // 4.20 Playground
    playgroundSamePremisesExisting: Yup.string().required("Required"),
    // playgroundSamePremisesRemarks: Yup.string().required("Required"),

    playgroundExtentExisting: Yup.string().when("playgroundSamePremisesExisting", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
    }),
    // playgroundExtentRemarks: Yup.string().when("playgroundSamePremisesExisting", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    // }),

    playgroundAlternativeExisting: Yup.string().when("playgroundSamePremisesExisting", {
      is: "No",
      then: (schema) => schema.required("Required"),
    }),
    // playgroundAlternativeRemarks: Yup.string().when("playgroundSamePremisesExisting", {
    //   is: "No",
    //   then: (schema) => schema.required("Required"),
    // }),

    playgroundMouExisting: Yup.string().when("playgroundSamePremisesExisting", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
    }),
    // playgroundMouRemarks: Yup.string().when("playgroundSamePremisesExisting", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    // }),

    // 4.21 Fire Safety
    fireSafetyCertificateExisting: Yup.string().required("Required"),
    // fireSafetyCertificateRemarks: Yup.string().required("Required"),

    // ********* Corpus Fund Section 7*******
    corpusFund: Yup.string().required("Required"),
    certificateIssued: Yup.string().when("corpusFund", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
    }),

    // ********** Staff Particulars Section 8*******
    staffAdequate: Yup.string().required("Required"),
    // staffAdequateRemarks: Yup.string().required("Required"),

    staffDeficiencies: Yup.string().when("staffAdequate", {
      is: "No",
      then: (schema) => schema.required("Required"),
    }),
    // staffDeficienciesRemarks: Yup.string().when("staffAdequate", {
    //   is: "No",
    //   then: (schema) => schema.required("Required"),
    // }),

    undertakingBondSubmitted: Yup.string().required("Required"),
    // undertakingBondRemarks: Yup.string().required("Required"),

    // Final Section
    finalRemarks: Yup.string().required("Required"),
    finalStatus: Yup.string().required("Required"),

    // Accommodation validation (Section 4.18)
    accomodation: Yup.array().of(
      Yup.object().shape({
        sufficientAsPerNorms: Yup.string().required("Required"),
        // remarks: Yup.string().required("Required"),
        particularName: Yup.string(),
        particularCode: Yup.string(),
      }),
    ),

    // Deficiencies validation
    deficiencies: Yup.array().of(
      Yup.object().shape({
        id: Yup.number(),
        deficiences: Yup.string().when("$finalStatus", {
          is: "DeficiencyIdentified",
          then: (schema) => schema.required("Required"),
        }),
      }),
    ),
  });
  const formik = useFormik({
    initialValues: {
      collCode: collCode,

      // *********socity basic details********
      regCertHandingover: "",
      regCertTakingover: "",
      regCertRemarks: "",

      byeLawsHandingover: "",
      byeLawsTakingover: "",
      byeLawsRemarks: "",

      resolutionsHandingover: "",
      resolutionsTakingover: "",
      resolutionsRemarks: "",

      resolutionValidHandingover: "",
      resolutionValidTakingover: "",
      resolutionValidRemarks: "",

      commonMembersExists: "",
      commonMembersRemarks: "",

      fixedAssetsTransfer: "",
      fixedAssetsRemarks: "",

      // **********College Basic Details*********
      collegeName: "",
      collegeNameRemarks: "",

      // surveyNo: "",
      doorNo: "",
      villageTown: "",
      collegeAddressRemarks: "",

      principalContactDetails: "",
      principalContactRemarks: "",

      jnanabhumiCode: "",
      jnanabhumiCodeRemarks: "",

      aisheCode: "",
      aisheCodeRemarks: "",

      yearOfEstablishment: "",
      yearOfEstablishmentRemarks: "",

      mandalName: "",
      mandalNameRemarks: "",

      districtName: "",
      districtNameRemarks: "",

      mandalStatus: "",
      mandalStatusRemarks: "",

      permissionOrderUploaded: "",
      permissionOrderRemarks: "",

      universityAffiliationUploaded: "",
      universityAffiliationRemarks: "",

      lastEopUploaded: "",
      lastEopRemarks: "",

      feeProofUploaded: "",
      feeProofRemarks: "",

      // *********** own land*********
      ownLandHandingover: "",
      ownLandTakingover: "",
      ownLandRemarks: "",

      landDeedProducedHandingover: "",
      landDeedProducedTakingover: "",
      landDeedProducedRemarks: "",

      landInSocietyNameHandingover: "",
      landInSocietyNameTakingover: "",
      landInSocietyNameRemarks: "",

      landInSameMandalHandingover: "",
      landInSameMandalTakingover: "",
      landInSameMandalRemarks: "",

      sketchPlanProducedHandingover: "",
      sketchPlanProducedTakingover: "",
      sketchPlanProducedRemarks: "",

      propertyScheduleTallyHandingover: "",
      propertyScheduleTallyTakingover: "",
      propertyScheduleTallyRemarks: "",

      // *************** Building Details***************
      // 4.1
      buildingAddressSurveyExisting: "",
      buildingAddressDoorExisting: "",
      buildingAddressTownExisting: "",
      buildingAddressProposed: "",
      buildingAddressRemarks: "",

      // 4.2
      sameMandalExisting: "",
      sameMandalProposed: "",
      sameMandalRemarks: "",

      // 4.3
      permanentBuildingExisting: "",
      permanentBuildingProposed: "",
      permanentBuildingRemarks: "",

      // 4.4
      distanceRequirementExisting: "",
      distanceRequirementProposed: "",
      distanceRequirementRemarks: "",

      // 4.5
      buildingOwnershipExisting: "",
      buildingOwnershipProposed: "",
      buildingOwnershipRemarks: "",

      // 4.6
      leasedDocumentExisting: "",
      leasedDocumentProposed: "",
      leasedDocumentRemarks: "",

      leaseRegisteredInSocietyExisting: "",
      leaseRegisteredInSocietyProposed: "",
      leaseRegisteredInSocietyRemarks: "",

      leaseRegistrationYearExisting: "",
      leaseRegistrationYearProposed: "",
      leaseRegistrationYearRemarks: "",

      leaseValidityFromExisting: "",
      leaseValidityToExisting: "",
      leaseValidityFromProposed: "",
      leaseValidityToProposed: "",
      leaseValidityRemarks: "",

      yearsCompletedExisting: "",
      yearsCompletedProposed: "",
      yearsCompletedRemarks: "",

      remainingLeaseRemarks: "",
      remainingLeaseYearsExisting: "",
      remainingLeaseYearsProposed: "",

      // 4.7
      saleDeedUploadedExisting: "",
      saleDeedUploadedProposed: "",
      saleDeedUploadedRemarks: "",

      // 4.8
      saleDeedInSocietyExisting: "",
      saleDeedInSocietyProposed: "",
      saleDeedInSocietyRemarks: "",

      // 4.9
      planApprovedExisting: "",
      planApprovedProposed: "",
      planApprovedRemarks: "",

      // 4.10
      approvedPlanUploadedExisting: "",
      approvedPlanUploadedProposed: "",
      approvedPlanUploadedRemarks: "",

      // 4.11
      carpetAreaExisting: "",
      carpetAreaProposed: "",
      carpetAreaRemarks: "",

      // 4.12
      constructionPermissionExisting: "",
      constructionPermissionProposed: "",
      constructionPermissionRemarks: "",

      // 4.13
      sanitaryCertificateExisting: "",
      sanitaryCertificateProposed: "",
      sanitaryCertificateRemarks: "",

      // 4.14
      geoTaggedPhotosExisting: "",
      geoTaggedPhotosProposed: "",
      geoTaggedPhotosRemarks: "",

      // 4.15
      otherInstitutionExisting: "",
      otherInstitutionProposed: "",
      otherInstitutionRemarks: "",

      // 4.16
      nocUploadedExisting: "",
      nocUploadedProposed: "",
      nocUploadedRemarks: "",

      // 4.17
      annexureDetailsExisting: "",
      annexureDetailsProposed: "",
      annexureDetailsRemarks: "",

      // ********* corpus fund*******
      corpusFund: "",
      certificateIssued: "",

      // ********** staff particulars*******
      staffAdequate: "",

      staffAdequateRemarks: "",

      staffDeficiencies: "",
      staffDeficienciesRemarks: "",

      undertakingBondSubmitted: "",
      undertakingBondRemarks: "",
      finalRemarks: "",
      finalStatus: "",

      // 4.19 Parking
      parkingAreaSamePremisesExisting: "",
      parkingAreaSamePremisesRemarks: "",

      parkingArea20PercentExisting: "",
      parkingArea20PercentRemarks: "",

      parkingAreaWithin100mExisting: "",
      parkingAreaWithin100mRemarks: "",
      parkingAreaWithin100mDocUploaded: "",
      parkingAreaWithin100mDocRemarks: "",

      // 4.20 Playground
      playgroundSamePremisesExisting: "",
      playgroundSamePremisesRemarks: "",

      playgroundExtentExisting: "",
      playgroundExtentRemarks: "",

      playgroundAlternativeExisting: "",
      playgroundAlternativeRemarks: "",

      playgroundMouExisting: "",
      playgroundMouRemarks: "",

      // 4.21 Fire Safety
      fireSafetyCertificateExisting: "",
      fireSafetyCertificateRemarks: "",

      // ******** deficiency****
      deficiencies: [
        {
          id: 1,
          deficiences: "",
        },
      ],

      accomodation: [],
    },
    enableReinitialize: true,
    validationSchema: validationSchema,


    onSubmit: (values) => {

      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to submit the data?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Submit",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          let url = config.url.FAC_URL + "saveNocManagementScrutinyDetails";
          const payload = {
            ...values,
            isSubmitted: true,
            accomodation:
              values.accomodation?.map((item) => ({
                sufficientAsPerNorms: item.sufficientAsPerNorms,
                remarks: item.remarks,
                particularName: item.particularName,
                particularCode: item.particularCode,
              })) || [],
          };
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                successAlert2(res.data.sdesc);
                getSocietyNameDetails();
                getShiftingScrutinyDetails();
                handleAccomidations();
                getPreviewDetails();
                getManagementScrutiny();
              } else {
                failureAlert(res.data.sdesc);
              }
            })
            .catch(() => failureAlert("Something went wrong"));
        }
      });
    },


  });
  console.log("formik errors", formik.errors);
  // ********** socity details***************
  function getSocietyNameDetails() {
    const url = `${config.url.FAC_URL}getSocietyNameChangeinspection/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.societyName_status === true) {
          setSocietyName(res?.data?.societyName || []);
        } else {
          setSocietyName([]);
        }
      })
      .catch((err) => {
        console.log("API Error:", err);
        setSocietyName([]);
      });
  }

  const handleSave = async () => {
    // const finalStatusSelected = formik.values.finalStatus && formik.values.finalStatus.trim() !== "";
    // if (finalStatusSelected) {
    //   const errors = await validationSchema
    //     .validate(formik.values, { abortEarly: false, context: formik.values })
    //     .then(() => ({}))
    //     .catch((err) => {
    //       const errorObj = {};
    //       err.inner.forEach((e) => {
    //         errorObj[e.path] = e.message;
    //       });
    //       return errorObj;
    //     });

    //   const isDeficienciesEmpty = !formik.values.deficiencies || formik.values.deficiencies.length === 0 || formik.values.deficiencies.every((d) => !d.deficiences || d.deficiences.trim() === "");
    //   const hasManualDeficiencyError = formik.values.finalStatus === "DeficiencyIdentified" && isDeficienciesEmpty;

    //   if (Object.keys(errors).length > 0 || hasManualDeficiencyError) {
    //     let extraMsg = "";
    //     if (formik.values.finalStatus === "DeficiencyIdentified") {
    //       const hasDeficiencyError = Object.keys(errors).some((k) => k.startsWith("deficiencies"));
    //       if (hasDeficiencyError || hasManualDeficiencyError) {
    //         extraMsg = "<br/><br/><strong style='color: red;'>Note: You must fill at least one deficiency.</strong>";
    //       }
    //     }

    //     Swal.fire({
    //       icon: "warning",
    //       title: "Cannot Save with Final Status",
    //       html: `You have selected a <strong>Final Status</strong> but some required fields are missing.${extraMsg}<br/><br/>
    //            To save as a <strong>draft</strong>, please clear the Final Status selection.<br/>
    //            Or fill all required fields before saving with Final Status.`,
    //       confirmButtonColor: "#d33",
    //       confirmButtonText: "OK",
    //     });
    //     return;
    //   }
    // }

    // ✅ Proceed to save
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        let url = config.url.FAC_URL + "saveNocManagementScrutinyDetails";
        const payload = {
          ...formik.values,
          isSubmitted: false,
          accomodation:
            formik.values.accomodation?.map((item) => ({
              sufficientAsPerNorms: item.sufficientAsPerNorms,
              remarks: item.remarks,
              particularName: item.particularName,
              particularCode: item.particularCode,
            })) || [],
        };
        CommonAxiosPost(url, payload)
          .then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2("Successfully Saved");
              getSocietyNameDetails();
              getShiftingScrutinyDetails();
              handleAccomidations();
              getPreviewDetails();
              getManagementScrutiny();
            } else {
              failureAlert(res.data.sdesc);
            }
          })
          .catch(() => failureAlert("Something went wrong"));
      }
    });
  };
  // ****** accomodastion details********
  function handleAccomidations() {
    let url = `${config.url.FAC_URL}getAccommodationAreaData/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          const accomData = res.data.data || [];
          setAccom(accomData);

          formik.setValues((prevValues) => {
            return {
              ...prevValues,
              accomodation: buildAccommodationRows(accomData, prevValues.accomodation),
            };
          });
        } else {
          setAccom([]);
          formik.setValues((prevValues) => ({
            ...prevValues,
            accomodation: Array.isArray(prevValues.accomodation) ? prevValues.accomodation : [],
          }));
        }
      })
      .catch((error) => {
        console.error("Error fetching accommodation details:", error);
        setAccom([]);
        formik.setValues((prevValues) => ({
          ...prevValues,
          accomodation: Array.isArray(prevValues.accomodation) ? prevValues.accomodation : [],
        }));
      });
  }
  const leasedDataFnc = async () => {
    let url = config.url.FAC_URL + "getleasedtls/" + collCode;
    try {
      const res = await CommonAxiosGet(url);
      if (res && res.data.status === true) {
        setLeasedData(res.data.leasedtls[0] || res.data.leasedtls || []);
        formik.setFieldValue("leaseRegistrationYearProposed", res.data.leasedtls[0].date_of_registration);
        formik.setFieldValue("leaseValidityFromProposed", res.data.leasedtls[0].leased_from);
        formik.setFieldValue("leaseValidityToProposed", res.data.leasedtls[0].leased_upto);
        formik.setFieldValue("yearsCompletedProposed", res.data.leasedtls[0].no_years);
        formik.setFieldValue("remainingLeaseYearsProposed", res.data.leasedtls[0].remain_years);
      } else {
        setLeasedData([]);
      }
    } catch (err) {
      console.error("Error fetching leased data:", err);
      setLeasedData([]);
    }
  };
  function getManagementScrutiny() {
    const url = `${config.url.FAC_URL}getManagementScrutiny?collCode=${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.mngmtScrutiny_status === true) {
          const scrutinyList = Array.isArray(res?.data?.mngmtScrutiny) ? res.data.mngmtScrutiny : [];
          const deficiencyList = res?.data?.mngmtScrutiny_def_status === true && Array.isArray(res?.data?.mngmtScrutiny_def) ? res.data.mngmtScrutiny_def : [];
          const accommodationList = res?.data?.mngmtScrutiny_accom_status === true && Array.isArray(res?.data?.mngmtScrutiny_accom) ? res.data.mngmtScrutiny_accom : [];
          const scrutinyData = scrutinyList[0] || {};

          setFinalSubmit(scrutinyData?.is_submitted || "");

          setManagementData(scrutinyList);

          if (scrutinyData && Object.keys(scrutinyData).length > 0) {
            const mappedAccommodation = accommodationList.map((item) => ({
              sufficientAsPerNorms: item.sufficientAsPerNorms || item.sufficient_as_per_norms || item.sufficient_orms || "",
              remarks: item.remarks || "",
              particularName: item.particular_name || "",
              particularCode: item.particular_code || "",
            }));

            const mappedDeficiencies =
              deficiencyList.length > 0
                ? deficiencyList.map((item, index) => ({
                  id: item.sno || index + 1,
                  deficiences: item.deficiences || "",
                }))
                : [];
            const mappedValues = {
              regCertHandingover: scrutinyData.reg_cert_handingover || "",
              regCertTakingover: scrutinyData.reg_cert_takingover || "",
              regCertRemarks: scrutinyData.reg_cert_remarks || "",
              byeLawsHandingover: scrutinyData.bye_laws_handingover || "",
              byeLawsTakingover: scrutinyData.bye_laws_takingover || "",
              byeLawsRemarks: scrutinyData.bye_laws_remarks || "",
              resolutionsHandingover: scrutinyData.resolutions_handingover || "",
              resolutionsTakingover: scrutinyData.resolutions_takingover || "",
              resolutionsRemarks: scrutinyData.resolutions_remarks || "",
              resolutionValidHandingover: scrutinyData.resolutionvalidhandingover || "",
              resolutionValidTakingover: scrutinyData.resolutionvalidtakingover || "",
              resolutionValidRemarks: scrutinyData.resolutionvalidremarks || "",
              commonMembersExists: scrutinyData.commonmembersexists || "",
              commonMembersRemarks: scrutinyData.commonmembersremarks || "",
              fixedAssetsTransfer: scrutinyData.fixedassetstransfer || "",
              fixedAssetsRemarks: scrutinyData.fixedassetsremarks || "",
              collegeNameRemarks: scrutinyData.college_name_remarks || "",
              collegeAddressRemarks: scrutinyData.college_address_remarks || "",
              principalContactRemarks: scrutinyData.principal_contact_remarks || "",
              jnanabhumiCodeRemarks: scrutinyData.jnanabhumi_code_remarks || "",
              aisheCodeRemarks: scrutinyData.aishe_code_remarks || "",
              yearOfEstablishmentRemarks: scrutinyData.year_of_establishment_remarks || "",
              mandalNameRemarks: scrutinyData.mandal_name_remarks || "",
              districtNameRemarks: scrutinyData.district_name_remarks || "",
              mandalStatus: scrutinyData.mandal_status || "",
              mandalStatusRemarks: scrutinyData.mandal_status_remarks || "",
              permissionOrderUploaded: scrutinyData.permission_order_uploaded || "",
              permissionOrderRemarks: scrutinyData.permission_order_remarks || "",
              universityAffiliationUploaded: scrutinyData.university_affiliation_uploaded || "",
              universityAffiliationRemarks: scrutinyData.university_affiliation_remarks || "",
              lastEopUploaded: scrutinyData.last_eop_uploaded || "",
              lastEopRemarks: scrutinyData.last_eop_remarks || "",
              feeProofUploaded: scrutinyData.fee_proof_uploaded || "",
              feeProofRemarks: scrutinyData.fee_proof_remarks || "",
              ownLandHandingover: scrutinyData.own_land_handingover || "",
              ownLandTakingover: scrutinyData.own_land_takingover || "",
              ownLandRemarks: scrutinyData.own_land_remarks || "",
              landDeedProducedHandingover: scrutinyData.land_deed_produced_handingover || "",
              landDeedProducedTakingover: scrutinyData.land_deed_produced_takingover || "",
              landDeedProducedRemarks: scrutinyData.land_deed_produced_remarks || "",
              landInSocietyNameHandingover: scrutinyData.land_in_society_name_handingover || "",
              landInSocietyNameTakingover: scrutinyData.land_in_society_name_takingover || "",
              landInSocietyNameRemarks: scrutinyData.land_in_society_name_remarks || "",
              landInSameMandalHandingover: scrutinyData.land_in_same_mandal_handingover || "",
              landInSameMandalTakingover: scrutinyData.land_in_same_mandal_takingover || "",
              landInSameMandalRemarks: scrutinyData.land_in_same_mandal_remarks || "",
              sketchPlanProducedHandingover: scrutinyData.sketch_plan_produced_handingover || "",
              sketchPlanProducedTakingover: scrutinyData.sketch_plan_produced_takingover || "",
              sketchPlanProducedRemarks: scrutinyData.sketch_plan_produced_remarks || "",
              propertyScheduleTallyHandingover: scrutinyData.property_schedule_tally_handingover || "",
              propertyScheduleTallyTakingover: scrutinyData.property_schedule_tally_takingover || "",
              propertyScheduleTallyRemarks: scrutinyData.property_schedule_tally_remarks || "",
              buildingAddressSurveyExisting: scrutinyData.building_address_survey_existing || "",
              buildingAddressDoorExisting: scrutinyData.building_address_door_existing || "",
              buildingAddressTownExisting: scrutinyData.building_address_town_existing || "",
              buildingAddressRemarks: scrutinyData.building_address_remarks || "",
              sameMandalExisting: scrutinyData.same_mandal_existing || "",
              sameMandalRemarks: scrutinyData.same_mandal_remarks || "",
              permanentBuildingExisting: scrutinyData.permanent_building_existing || "",
              permanentBuildingRemarks: scrutinyData.permanent_building_remarks || "",
              distanceRequirementExisting: scrutinyData.distance_requirement_existing || "",
              distanceRequirementRemarks: scrutinyData.distance_requirement_remarks || "",
              buildingOwnershipExisting: scrutinyData.building_ownership_existing || "",
              buildingOwnershipRemarks: scrutinyData.building_ownership_remarks || "",
              leasedDocumentExisting: scrutinyData.leased_document_existing || "",
              leasedDocumentRemarks: scrutinyData.leased_document_remarks || "",
              leaseRegisteredInSocietyExisting: scrutinyData.lease_registered_in_society_existing || "",
              leaseRegisteredInSocietyRemarks: scrutinyData.lease_registered_in_society_remarks || "",
              leaseRegistrationYearExisting: scrutinyData.lease_registration_year_existing || "",
              leaseRegistrationYearRemarks: scrutinyData.lease_registration_year_remarks || "",
              leaseValidityFromExisting: scrutinyData.lease_validity_from_existing || "",
              leaseValidityToExisting: scrutinyData.lease_validity_to_existing || "",
              leaseValidityRemarks: scrutinyData.lease_validity_remarks || "",
              yearsCompletedExisting: scrutinyData.years_completed_existing || "",
              yearsCompletedRemarks: scrutinyData.years_completed_remarks || "",
              remainingLeaseYearsExisting: scrutinyData.remaining_lease_years_existing || "",
              remainingLeaseRemarks: scrutinyData.remaining_lease_remarks || "",
              saleDeedUploadedExisting: scrutinyData.sale_deed_uploaded_existing || "",
              saleDeedUploadedRemarks: scrutinyData.sale_deed_uploaded_remarks || "",
              saleDeedInSocietyExisting: scrutinyData.sale_deed_in_society_existing || "",
              saleDeedInSocietyRemarks: scrutinyData.sale_deed_in_society_remarks || "",
              planApprovedExisting: scrutinyData.plan_approved_existing || "",
              planApprovedRemarks: scrutinyData.plan_approved_remarks || "",
              approvedPlanUploadedExisting: scrutinyData.approved_plan_uploaded_existing || "",
              approvedPlanUploadedRemarks: scrutinyData.approved_plan_uploaded_remarks || "",
              carpetAreaExisting: scrutinyData.carpet_area_existing || "",
              carpetAreaRemarks: scrutinyData.carpet_area_remarks || "",
              constructionPermissionExisting: scrutinyData.construction_permission_existing || "",
              constructionPermissionRemarks: scrutinyData.construction_permission_remarks || "",
              sanitaryCertificateExisting: scrutinyData.sanitary_certificate_existing || "",
              sanitaryCertificateRemarks: scrutinyData.sanitary_certificate_remarks || "",
              geoTaggedPhotosExisting: scrutinyData.geo_tagged_photos_existing || "",
              geoTaggedPhotosRemarks: scrutinyData.geo_tagged_photos_remarks || "",
              otherInstitutionExisting: scrutinyData.other_institution_existing || "",
              otherInstitutionRemarks: scrutinyData.other_institution_remarks || "",
              nocUploadedExisting: scrutinyData.noc_uploaded_existing || "",
              nocUploadedRemarks: scrutinyData.noc_uploaded_remarks || "",
              annexureDetailsExisting: scrutinyData.annexure_details_existing || "",
              annexureDetailsRemarks: scrutinyData.annexure_details_remarks || "",
              corpusFund: scrutinyData.corpus_fund || "",
              certificateIssued: scrutinyData.certificate_issued || "",
              staffAdequate: scrutinyData.staff_adequate || "",
              staffAdequateRemarks: scrutinyData.staff_adequate_remarks || "",
              staffDeficiencies: scrutinyData.staff_deficiencies || "",
              staffDeficienciesRemarks: scrutinyData.staff_deficiencies_remarks || "",
              undertakingBondSubmitted: scrutinyData.undertaking_bond_submitted || "",
              undertakingBondRemarks: scrutinyData.undertaking_bond_remarks || "",
              finalRemarks: scrutinyData.final_remarks || "",
              finalStatus: scrutinyData.final_status || "",
              parkingAreaSamePremisesExisting: scrutinyData.parking_area_same_premises_existing || "",
              parkingAreaSamePremisesRemarks: scrutinyData.parking_area_same_premises_remarks || "",
              parkingArea20PercentExisting: scrutinyData.parking_area_20_percent_existing || "",
              parkingArea20PercentRemarks: scrutinyData.parking_area_20_percent_remarks || "",
              parkingAreaWithin100mExisting: scrutinyData.parking_area_within_100m_existing || "",
              parkingAreaWithin100mDocUploaded: scrutinyData.parking_area_doc_uploaded || "",
              parkingAreaWithin100mDocRemarks: scrutinyData.parking_area_within_100m_doc_remarks || "",
              parkingAreaWithin100mRemarks: scrutinyData.parking_area_within_100m_remarks || "",
              playgroundSamePremisesExisting: scrutinyData.playground_same_premises_existing || "",
              playgroundSamePremisesRemarks: scrutinyData.playground_same_premises_remarks || "",
              playgroundExtentExisting: scrutinyData.playground_extent_existing || "",
              playgroundExtentRemarks: scrutinyData.playground_extent_remarks || "",
              playgroundAlternativeExisting: scrutinyData.playground_alternative_existing || "",
              playgroundAlternativeRemarks: scrutinyData.playground_alternative_remarks || "",
              playgroundMouExisting: scrutinyData.playground_mou_existing || "",
              playgroundMouRemarks: scrutinyData.playground_mou_remarks || "",
              fireSafetyCertificateExisting: scrutinyData.fire_safety_certificate_existing || "",
              fireSafetyCertificateRemarks: scrutinyData.fire_safety_certificate_remarks || "",
              deficiencies: mappedDeficiencies,
              accomodation: mappedAccommodation,
            };

            formik.setValues((prevValues) => mergeManagementScrutinyValues(prevValues, mappedValues));

            if (!isEmptyFormValue(mappedValues.finalStatus)) {
              setSelectedFinalStatus((currentStatus) => currentStatus || mappedValues.finalStatus);
            }
          }
        } else {
          setManagementData([]);
        }
      })
      .catch((err) => {
        console.log("API Error:", err);
        setManagementData([]);
      });
  }
  useEffect(() => {
    getSocietyNameDetails();
    getShiftingScrutinyDetails();
    handleAccomidations();
    getPreviewDetails();
    getManagementScrutiny();
    leasedDataFnc();
  }, []);
  const society = societyName?.length > 0 ? societyName[0] : {};

  function getShiftingScrutinyDetails() {
    let url = config.url.FAC_URL + `getScrutinyDetails/${collCode}/${nocType}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          // Main Values
          setApiValues(res?.data?.data?.[0] || {});
          setParking(res?.data?.parking?.[0] || {});
          setUgCourse(res?.data?.ugCourses || []);
          setPgCourses(res?.data?.pgCourses || []);

          // BUILD AREA
          // setAccom(res?.data?.buildArea || []);

          // INSTALLMENTS
          const installData = Array.isArray(res?.data?.corpusFundInstall) ? res.data.corpusFundInstall : [];

          setcorpusFundInstall(installData);

          // CORPUS UG / PG

          const corpusData = Array.isArray(res?.data?.corpusfundUGPG) ? res.data.corpusfundUGPG : [];

          const ugFunds = corpusData.filter((item) => item.coll_type?.toLowerCase().trim() === "ug");
          const pgBeforeFunds = corpusData.filter((item) => item.coll_type?.toLowerCase().trim() === "pg before");
          const pgAfterFunds = corpusData.filter((item) => item.coll_type?.toLowerCase().trim() === "pg after");

          setUgCorpusFunds(ugFunds);
          setPGBEFORE(pgBeforeFunds);
          setPgCorpusFunds(pgAfterFunds);
        } else {
          setApiValues({});
          setAccom([]);
          setpgAcc([]);

          setcorpusFundInstall([]);
          setUgCorpusFunds([]);
          setPGBEFORE([]);
          setPgCorpusFunds([]);
        }
      })

      .catch((err) => {
        console.log("API Error:", err);
      });
  }

  // ************* preview***********
  function getPreviewDetails() {
    const url = `${config.url.FAC_URL}getPreView?collCode=${collCode}&nocType=management`;

    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.scode === "01") {
          setNocdata(res?.data);

          const instDetails = res?.data?.instDetails?.[0] || {};
          const landData = res?.data?.land?.[0] || {};
          // const docs = res?.data?.document || [];

          const docs = Array.isArray(res?.data?.document) ? res.data.document : [];
          const managementDocs = docs.filter((item) => item.noc_type === "management");

          // ✅ store API land data ONLY
          setLandDetails(landData);

          setBuildingDocs(managementDocs);

          formik.setValues((prevValues) => ({
            ...prevValues,

            // College Details
            collegeName: instDetails.inst_name || "",
            doorNo: instDetails.inst_address || "",
            villageTown: instDetails.place_town || "",
            principalContactDetails: `${instDetails.principle_name || ""} ${instDetails.principle_mobile || ""} ${instDetails.principle_email || ""}`,
            jnanabhumiCode: instDetails.coll_code || "",
            aisheCode: instDetails.aishe_code || "",
            yearOfEstablishment: instDetails.year_of_establishment || "",
            mandalName: instDetails.mandal_name || "",
            districtName: instDetails.dist_name || "",

            // ************building details*********
            // buildingAddressSurveyExisting: landData.survey_no || "",
            // buildingAddressTownExisting: landData.village_name || "",
            leaseRegisteredInSocietyProposed: landData.society || prevValues.leaseRegisteredInSocietyProposed || "",
            // yearsCompletedProposed: landData.no_years || prevValues.yearsCompletedProposed || "",
            otherInstitutionProposed: landData.same_primises ? "Yes" : "No",

            buildingOwnershipProposed: landData?.build_own_lease ? "Own" : "Leased",
          }));
        }
      })
      .catch((error) => {
        // console.log("Preview API Error:", error);
      });
  }

  const hasDocument = (docId) => {
    return buildingDocs?.some((doc) => doc.doc_id === docId && doc.doc_path);
  };

  // Function to get doc_path by doc_id and view the document
  const viewDocumentById = (docId) => {
    const document = buildingDocs?.find((doc) => doc.doc_id === docId);
    if (document?.doc_path) {
      viewImage(document.doc_path);
    } else {
      console.error(`Document with ID ${docId} not found or missing doc_path`);
    }
  };
  const handleLandOwnershipRadioChange = (e) => {
    const { name, value } = e.target;

    // Set radio value
    formik.setFieldValue(name, value);

    const mapping = {
      ownLandHandingover: "ownLandTakingover",
      landDeedProducedHandingover: "landDeedProducedTakingover",
      landInSocietyNameHandingover: "landInSocietyNameTakingover",
      landInSameMandalHandingover: "landInSameMandalTakingover",
      sketchPlanProducedHandingover: "sketchPlanProducedTakingover",
      propertyScheduleTallyHandingover: "propertyScheduleTallyTakingover",
    };

    const takingField = mapping[name];

    if (!takingField) return;

    // ✅ YES → Populate
    if (value === "Yes") {
      let autoValue = "";

      switch (name) {
        case "ownLandHandingover":
          autoValue = landDetails?.society || "";
          break;

        case "landDeedProducedHandingover":
          autoValue = landDetails?.lease_deed ? "Yes" : "No";

          break;

        // case "landInSocietyNameHandingover":
        //   autoValue = landDetails?.society || "";
        //   break;

        case "landInSameMandalHandingover":
          autoValue = landDetails?.mandal_name;
          break;

        // case "sketchPlanProducedHandingover":
        //   autoValue = landDetails?.khasra_plan_file ? "Yes" : "No";
        //   break;

        // case "propertyScheduleTallyHandingover":
        //   autoValue = landDetails?.survey_no ? "Yes" : "No";
        //   break;

        default:
          autoValue = "";
      }

      formik.setFieldValue(takingField, autoValue);
    }

    // ❌ NO → Clear
    if (value === "No") {
      formik.setFieldValue(takingField, "");
    }
  };

  const handleLandRadioChange = (e) => {
    formik.setFieldValue(e.target.name, e.target.value);
  };
  const handleBuildingSameAsExisting = (event) => {
    const isChecked = event.target.checked;
    setIsBuildingSameAsExisting(isChecked);

    if (isChecked) {
      Object.entries(buildingFieldPairs).forEach(([existingField, proposedField]) => {
        formik.setFieldValue(proposedField, formik.values[existingField]);
      });
    }
  };
  const firstInstallment = corpusFundInstall.find((i) => i.installment_no === 1) || {};

  const secondInstallment = corpusFundInstall.find((i) => i.installment_no === 2) || {};

  const thirdInstallment = corpusFundInstall.find((i) => i.installment_no === 3) || {};

  const currentFinalStatus = (selectedFinalStatus || formik.values.finalStatus || "").trim();
  const showDeficienciesSection = currentFinalStatus === "DeficiencyIdentified";

  const handleFinalStatusChange = (event) => {
    const { value } = event.target;
    setSelectedFinalStatus(value);
    formik.setFieldValue("finalStatus", value);
    if (value !== "DeficiencyIdentified") {
      formik.setFieldValue("deficiencies", [
        {
          id: 1,
          deficiences: "",
        },
      ]);
    }
  };

  // Handler function - add this in your Management Scrutiny component
  const handleDownloadManagementPDF = () => {
    const url = `${config.url.FAC_URL}getManagementScrutiny?collCode=${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.mngmtScrutiny_status === true) {
          const deficiencyData = res.data.mngmtScrutiny_def_status === true && Array.isArray(res.data.mngmtScrutiny_def) ? res.data.mngmtScrutiny_def : [];

          const scrutinyData = Array.isArray(res.data.mngmtScrutiny) ? res.data.mngmtScrutiny[0] || {} : {};

          if (deficiencyData.length > 0) {
            const rowData = {
              inst_name: apiValues.inst_name || apiValues.society_name || "College",
              coll_code: collCode,
              noc_type: "management",
              final_remarks: scrutinyData.final_remarks || "",
              final_status: scrutinyData.final_status || "",
              deficiencies: deficiencyData.map((item) => ({
                remarks:
                  item.deficiences || // note: typo in API is intentional
                  item.deficiency_description ||
                  item.remarks ||
                  "",
              })),
            };

            generateManagementDeficienciesPdf(rowData);
          } else {
            Swal.fire({
              icon: "info",
              title: "No Deficiencies",
              text: "No deficiencies found to download",
              confirmButtonColor: "#3085d6",
            });
          }
        } else {
          Swal.fire({
            icon: "info",
            title: "No Data",
            text: "No management scrutiny data available",
            confirmButtonColor: "#3085d6",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching management deficiencies:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch deficiencies. Please try again.",
          confirmButtonColor: "#d33",
        });
      });
  };
  const textareaStyle = {
    height: "auto",
    resize: "vertical",
  };
  // console.log("Is Submitting:", formik.isSubmitting);
  console.log("formik errors>>", formik.errors);



  // const handleFinalSubmit = async () => {

  //   // STEP 1: run Yup validation
  //   const errors = await formik.validateForm();

  //   const hasErrors = Object.keys(errors).length > 0;

  //   // STEP 2: mark fields touched so UI shows errors
  //   formik.setTouched(
  //     Object.keys(formik.values).reduce((acc, key) => {
  //       acc[key] = true;
  //       return acc;
  //     }, {})
  //   );

  //   // STEP 3: if errors → show Swal + stop
  //   if (hasErrors) {

  //     Swal.fire({
  //       icon: "warning",
  //       title: "Please fill all required fields"
  //     });

  //     return;
  //   }

  //   // STEP 4: valid → trigger normal Formik submit
  //   formik.handleSubmit();
  // };
const handleFinalSubmit = async () => {
 
    // STEP 1: run Yup validation
    const errors = await formik.validateForm();
 
    const hasErrors = Object.keys(errors).length > 0;
 
    // STEP 2: mark fields touched so UI shows errors
    const setAllTouched = (values) => {
      const touched = {};
      Object.keys(values).forEach((key) => {
        if (Array.isArray(values[key])) {
          touched[key] = values[key].map((item) => {
            if (typeof item === 'object' && item !== null) {
              const itemTouched = {};
              Object.keys(item).forEach((k) => {
                itemTouched[k] = true;
              });
              return itemTouched;
            }
            return true;
          });
        } else {
          touched[key] = true;
        }
      });
      return touched;
    };
 
    formik.setTouched(setAllTouched(formik.values));
 
    // STEP 3: if errors → show Swal + stop
    if (hasErrors) {
 
      Swal.fire({
        icon: "warning",
        title: "Please fill all required fields"
      });
 
      return;
    }
 
    // STEP 4: valid → trigger normal Formik submit
    formik.handleSubmit();
  };

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange}>
        {/* ************ Socity details*********** */}
        <Row className="mb-4">
          <Col>
            <h5 className="text-success mb-3">{`Scrutiny form for Change of Management of ${instName} for The Academic Year 2026-27`}</h5>{" "}
            <Table bordered responsive className="scrutiny-report-table">
              <thead className="table-primary text-center">
                <tr>
                  <th>Name of the Handing-over Society and Address</th>
                  <th>Name of the Taking-over Society and Address</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* CURRENT DETAILS */}
                  <td>
                    <div className="mb-2">
                      <strong>Society Name:</strong> {society.current_name_of_trust || "-"}
                    </div>

                    <div className="mb-2">
                      <strong>Village / Town:</strong> {society.village_name || "-"}
                    </div>

                    <div className="mb-2">
                      <strong>Mandal:</strong> {society.mandal_name || "-"}
                    </div>

                    <div>
                      <strong>District:</strong> {society.dist_name || "-"}
                    </div>
                  </td>

                  {/* PROPOSED DETAILS */}
                  <td>
                    <div className="mb-2">
                      <strong>Society Name:</strong> {society.proposed_new_name || "-"}
                    </div>

                    <div className="mb-2">
                      <strong>Village / Town:</strong> {society.village_name || "-"}
                    </div>

                    <div className="mb-2">
                      <strong>Mandal:</strong> {society.mandal_name || "-"}
                    </div>

                    <div>
                      <strong>District:</strong> {society.dist_name || "-"}
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* *************Society Basic Details************* */}
        <Row>
          <Col>
            <h5 className="text-success mb-3">1. Basic Details of the Societies </h5>
            <Table bordered responsive className="scrutiny-report-table">
              <thead className="table-primary text-center">
                <tr>
                  <th>S. No</th>
                  <th>Societies Details</th>
                  <th>Handing-over Society</th>
                  <th>Taking-over Society</th>
                  <th>Remarks of the Scrutiny Committee</th>
                </tr>
              </thead>

              <tbody>
                {/* 1.1 */}
                <tr>
                  <td className="text-center">1.1</td>
                  <td>Whether the Registration certificate of the Society is uploaded</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="regCertHandingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="regCertHandingover" value="No" /> No
                    <ErrorMessage name="regCertHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="regCertTakingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="regCertTakingover" value="No" /> No
                    <ErrorMessage name="regCertTakingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="regCertRemarks" className="form-control" />
                    <ErrorMessage name="regCertRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 1.2 */}
                <tr>
                  <td className="text-center">1.2</td>
                  <td>Whether a copy of the Bye-laws of the Society is uploaded</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="byeLawsHandingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="byeLawsHandingover" value="No" /> No
                    <ErrorMessage name="byeLawsHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="byeLawsTakingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="byeLawsTakingover" value="No" /> No
                    <ErrorMessage name="byeLawsTakingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="byeLawsRemarks" className="form-control" />
                    <ErrorMessage name="byeLawsRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 1.3 */}
                <tr>
                  <td className="text-center">1.3</td>
                  <td>Whether a copy of the Resolutions of the Society for Change of Management is uploaded</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="resolutionsHandingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="resolutionsHandingover" value="No" /> No
                    <ErrorMessage name="resolutionsHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="resolutionsTakingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="resolutionsTakingover" value="No" /> No
                    <ErrorMessage name="resolutionsTakingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="resolutionsRemarks" className="form-control" />
                    <ErrorMessage name="resolutionsRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 1.4 */}
                <tr>
                  <td className="text-center">1.4</td>
                  <td>Whether the resolution(s) made is valid as per bye-laws</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="resolutionValidHandingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="resolutionValidHandingover" value="No" /> No
                    <ErrorMessage name="resolutionValidHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="resolutionValidTakingover" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="resolutionValidTakingover" value="No" /> No
                    <ErrorMessage name="resolutionValidTakingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="resolutionValidRemarks" className="form-control" />
                    <ErrorMessage name="resolutionValidRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 1.5 */}
                <tr>
                  <td className="text-center">1.5</td>
                  <td>If any member(s) of the society is/are common member(s) of both the societies, provide details in remarks</td>

                  <td colSpan="2" style={{ textAlign: "center" }}>
                    <Field type="radio" name="commonMembersExists" value="Yes" /> Yes, with details &nbsp;
                    <Field type="radio" name="commonMembersExists" value="No" /> No
                    <ErrorMessage name="commonMembersExists" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="commonMembersRemarks" className="form-control" />
                    <ErrorMessage name="commonMembersRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 1.6 */}
                <tr>
                  <td className="text-center">1.6</td>
                  <td>If the change of management also involves the transfer of fixed assets i.e, land and building, mention the details.</td>

                  <td colSpan="2" style={{ textAlign: "center" }}>
                    <Field type="radio" name="fixedAssetsTransfer" value="Yes" /> Yes, with details &nbsp;
                    <Field type="radio" name="fixedAssetsTransfer" value="No" /> No
                    <ErrorMessage name="fixedAssetsTransfer" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="fixedAssetsRemarks" className="form-control" />
                    <ErrorMessage name="fixedAssetsRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* ****************College Basic Details**************** */}
        <Row>
          <Col>
            <h5 className="text-success mb-3 mt-4">2. Basic Details of the College</h5>

            <Table bordered responsive className="scrutiny-report-table">
              <thead className="table-primary text-center">
                <tr>
                  <th style={{ width: "5%" }}>Sl.No</th>
                  <th style={{ width: "50%" }}>Details</th>
                  <th style={{ width: "15%" }}>Please tick</th>
                  <th style={{ width: "25%" }}>Remarks of the Scrutiny Committee</th>
                </tr>
              </thead>

              <tbody>
                {/* 2.1 */}
                <tr>
                  <td className="text-center">2.1</td>
                  <td>Name of the College</td>
                  <td>{formik.values.collegeName ? <span className="fw-bold">{formik.values.collegeName}</span> : null}</td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="collegeNameRemarks" className="form-control" />
                    <ErrorMessage name="collegeNameRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.2 */}
                <tr>
                  <td className="text-center">2.2</td>
                  <td>Address of the Colleges</td>
                  <td>
                    {formik.values.doorNo && (
                      <span className="fw-bold">
                        {formik.values.doorNo}
                        <br />
                      </span>
                    )}
                    {formik.values.villageTown && <span className="fw-bold">{formik.values.villageTown}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="collegeAddressRemarks" className="form-control" />
                    <ErrorMessage name="collegeAddressRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.3 */}
                <tr>
                  <td className="text-center">2.3</td>
                  <td>Name and Contact Details of the Principal of the College (email, Mobile etc.) </td>
                  <td>{formik.values.principalContactDetails ? <span className="fw-bold">{formik.values.principalContactDetails}</span> : null}</td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="principalContactRemarks" className="form-control" />
                    <ErrorMessage name="principalContactRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.4 */}
                <tr>
                  <td className="text-center">2.4</td>
                  <td>Jnanabhumi Code of the College </td>
                  <td>{formik.values.jnanabhumiCode ? <span className="fw-bold">{formik.values.jnanabhumiCode}</span> : null}</td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="jnanabhumiCodeRemarks" className="form-control" />
                    <ErrorMessage name="jnanabhumiCodeRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.5 */}
                <tr>
                  <td className="text-center">2.5</td>
                  <td>AISHE Code</td>
                  <td>{formik.values.aisheCode ? <span className="fw-bold">{formik.values.aisheCode}</span> : null}</td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="aisheCodeRemarks" className="form-control" />
                    <ErrorMessage name="aisheCodeRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.6 */}
                <tr>
                  <td className="text-center">2.6</td>
                  <td>Year of Establishment</td>
                  <td>{formik.values.yearOfEstablishment ? <span className="fw-bold">{formik.values.yearOfEstablishment}</span> : null}</td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="yearOfEstablishmentRemarks" className="form-control" />
                    <ErrorMessage name="yearOfEstablishmentRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.7 */}
                <tr>
                  <td className="text-center">2.7</td>
                  <td>Name of the Mandal where the existing college is located </td>
                  <td>{formik.values.mandalName ? <span className="fw-bold">{formik.values.mandalName}</span> : null}</td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="mandalNameRemarks" className="form-control" />
                    <ErrorMessage name="mandalNameRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.8 */}
                <tr>
                  <td className="text-center">2.8</td>
                  <td>Name of the District where the existing college is located </td>
                  <td>{formik.values.districtName ? <span className="fw-bold">{formik.values.districtName}</span> : null}</td>

                  <td>
                    <Field name="districtNameRemarks" as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" />
                    <ErrorMessage name="districtNameRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.9 */}
                <tr>
                  <td className="text-center">2.9</td>
                  <td>Status of Mandal</td>
                  <td>
                    <Field as="select" name="mandalStatus" className="form-control">
                      <option value="">-- Select --</option>
                      <option value="Rural">Rural</option>
                      <option value="Urban">Urban</option>
                      <option value="Tribal">Tribal</option>
                    </Field>

                    <ErrorMessage name="mandalStatus" component="div" className="text-danger small" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="mandalStatusRemarks" className="form-control" />
                    <ErrorMessage name="mandalStatusRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.10 */}
                <tr>
                  <td className="text-center">2.10</td>
                  <td>Whether a copy of the permission order granted for the establishment of the college is uploaded. </td>
                  <td>
                    <Field type="radio" name="permissionOrderUploaded" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="permissionOrderUploaded" value="No" /> No&nbsp;
                    <ErrorMessage name="permissionOrderUploaded" component="div" className="text-danger small" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="permissionOrderRemarks" className="form-control" />
                    <ErrorMessage name="permissionOrderRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.11 */}
                <tr>
                  <td className="text-center">2.11</td>
                  <td>University affiliation order (2025-26) is uploaded</td>
                  <td>
                    <Field type="radio" name="universityAffiliationUploaded" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="universityAffiliationUploaded" value="No" /> No&nbsp;
                    <ErrorMessage name="universityAffiliationUploaded" component="div" className="text-danger small" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="universityAffiliationRemarks" className="form-control" />
                    <ErrorMessage name="universityAffiliationRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.12 */}
                <tr>
                  <td className="text-center">2.12</td>
                  <td>Whether a copy of the last EoP granted is uploaded </td>
                  <td>
                    <Field type="radio" name="lastEopUploaded" value="Yes" /> Yes &nbsp;
                    <Field type="radio" name="lastEopUploaded" value="No" /> No&nbsp;
                    <ErrorMessage name="lastEopUploaded" component="div" className="text-danger small" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="lastEopRemarks" className="form-control" />
                    <ErrorMessage name="lastEopRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 2.13 */}
                <tr>
                  <td className="text-center">2.13</td>
                  {/* <td>Whether proof of the registration and processing fee paid is uploaded</td> */}
                  {/* <td>
                    <Field type="radio" name="feeProofUploaded" value={apiValues.transaction_id} /> Yes&nbsp;
                    <Field type="radio" name="feeProofUploaded" value="No" /> No&nbsp;
                    <ErrorMessage name="feeProofUploaded" component="div" className="text-danger small" />
                  </td> */}
                   <td>Transaction Id</td>
                  <td>
                    {apiValues.transaction_id ? (
                      <span className="fw-bold text-success">
                        {apiValues.transaction_id}
                      </span>
                    ) : (
                      <span className="text-muted">Not uploaded</span>
                    )}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="feeProofRemarks" className="form-control" />
                    <ErrorMessage name="feeProofRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* ****************** Own Land Details**************** * */}
        <Row>
          <Col>
            <h5 className="text-success mb-3 mt-4">3. Details of the Own Land</h5>

            <Table bordered responsive className="scrutiny-report-table">
              <thead className="table-primary text-center">
                <tr>
                  <th style={{ width: "5%" }}>Sl.No</th>
                  <th style={{ width: "40%" }}>Land Details</th>
                  <th style={{ width: "10%" }}>Handing-over Society</th>
                  <th style={{ width: "10%" }}>Taking-over Society (If same as Handing-over Society: auto populate)</th>
                  <th style={{ width: "25%" }}>Remarks of the Scrutiny Committee</th>
                </tr>
              </thead>

              <tbody>
                {/* 3.1 */}
                <tr>
                  <td className="text-center">3.1</td>
                  <td>Whether the society has own land as per norms</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="ownLandHandingover" value="Yes" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                    <Field type="radio" name="ownLandHandingover" value="No" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> No&nbsp;
                    <ErrorMessage name="ownLandHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    {formik.values.ownLandHandingover !== "Yes" && <Field type="text" name="ownLandTakingover" className="form-control" />}
                    {formik.values.ownLandHandingover === "Yes" && landDetails?.society && <span className="fw-bold">{landDetails.society}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="ownLandRemarks" className="form-control" />
                    <ErrorMessage name="ownLandRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 3.2 */}
                <tr>
                  <td className="text-center">3.2</td>
                  <td>Whether the registered ownership of the land deed is produced</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="landDeedProducedHandingover" value="Yes" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                    <Field type="radio" name="landDeedProducedHandingover" value="No" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> No&nbsp;
                    <ErrorMessage name="landDeedProducedHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    {/* Show Yes/No only */}
                    {formik.values.landDeedProducedHandingover !== "Yes" && (
                      <>
                        <Field type="text" name="landDeedProducedTakingover" className="form-control" />

                        {/* <ErrorMessage name="landDeedProducedTakingover" component="div" className="text-danger small mt-1" /> */}
                      </>
                    )}

                    {/* ✅ Show Document Button */}

                    {formik.values.landDeedProducedHandingover === "Yes" && landDetails?.lease_deed && (
                      <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewImage(landDetails?.lease_deed)}>
                        <FaEye size={20} />
                      </button>
                    )}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="landDeedProducedRemarks" className="form-control" />
                    <ErrorMessage name="landDeedProducedRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 3.3 */}
                <tr>
                  <td className="text-center">3.3</td>
                  <td>Whether the registered document of the land owned in the name of the Society</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="landInSocietyNameHandingover" value="Yes" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                    <Field type="radio" name="landInSocietyNameHandingover" value="No" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> No&nbsp;
                    <ErrorMessage name="landInSocietyNameHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    {formik.values.landInSocietyNameHandingover !== "Yes" && <Field type="text" name="landInSocietyNameTakingover" className="form-control" />}
                    {formik.values.landInSocietyNameHandingover === "Yes" && landDetails?.society && <span className="fw-bold">{landDetails.society}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="landInSocietyNameRemarks" className="form-control" />
                    <ErrorMessage name="landInSocietyNameRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 3.4 */}
                <tr>
                  <td className="text-center">3.4</td>
                  <td>Whether the own land is provided in the same Mandal</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="landInSameMandalHandingover" value="Yes" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                    <Field type="radio" name="landInSameMandalHandingover" value="No" onChange={handleLandOwnershipRadioChange} onBlur={formik.handleBlur} /> No&nbsp;
                    <ErrorMessage name="landInSameMandalHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    {formik.values.landInSameMandalHandingover !== "Yes" && <Field type="text" name="landInSameMandalTakingover" className="form-control" />}
                    {formik.values.landInSameMandalHandingover === "Yes" && landDetails?.mandal_name && <span className="fw-bold">{landDetails.mandal_name}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="landInSameMandalRemarks" className="form-control" />
                    <ErrorMessage name="landInSameMandalRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 3.5 */}
                <tr>
                  <td className="text-center">3.5</td>
                  <td>Whether the sketch plan of own land drawn by the licensed surveyor and attested by the MRO is produced</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="sketchPlanProducedHandingover" value="Yes" onChange={handleLandRadioChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                    <Field type="radio" name="sketchPlanProducedHandingover" value="No" onChange={handleLandRadioChange} onBlur={formik.handleBlur} /> No&nbsp;
                    <ErrorMessage name="sketchPlanProducedHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    {formik.values.sketchPlanProducedHandingover !== "Yes" && <Field type="text" name="sketchPlanProducedTakingover" className="form-control" />}
                    {formik.values.sketchPlanProducedHandingover === "Yes" && landDetails?.khasra_plan_file && (
                      <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewImage(landDetails?.khasra_plan_file)}>
                        <FaEye size={20} />
                      </button>
                    )}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="sketchPlanProducedRemarks" className="form-control" />
                    <ErrorMessage name="sketchPlanProducedRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>

                {/* 3.6 */}
                <tr>
                  <td className="text-center">3.6</td>
                  <td>Whether the schedule of property mentioned in the registered ownership deed is tallying with the sketch plan produced</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="propertyScheduleTallyHandingover" value="Yes" onChange={handleLandRadioChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                    <Field type="radio" name="propertyScheduleTallyHandingover" value="No" onChange={handleLandRadioChange} onBlur={formik.handleBlur} /> No&nbsp;
                    <ErrorMessage name="propertyScheduleTallyHandingover" component="div" className="text-danger small mt-1" />
                  </td>

                  <td>
                    {formik.values.propertyScheduleTallyHandingover !== "Yes" && <Field type="text" name="propertyScheduleTallyTakingover" className="form-control" />}
                    {formik.values.propertyScheduleTallyHandingover === "Yes" && landDetails?.survey_no && <span className="fw-bold">{landDetails.survey_no}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" name="propertyScheduleTallyRemarks" className="form-control" />
                    <ErrorMessage name="propertyScheduleTallyRemarks" component="div" className="text-danger small mt-1" />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* **********Building details********* */}
        <Row>
          <Col>
            <h5 className="text-success mb-3 mt-4">4. Details of the Building</h5>
            <Table bordered responsive className="scrutiny-report-table">
              <thead className="table-primary text-center">
                <tr>
                  <th style={{ width: "5%" }}>S. No.</th>
                  <th style={{ width: "40%" }}>Building Details</th>
                  <th style={{ width: "15%" }}>Existing</th>
                  <th style={{ width: "10%" }}>Proposed (If same as existing: auto populate)</th>
                  <th style={{ width: "25%" }}>Remarks of the Scrutiny Committee</th>
                </tr>
              </thead>

              <tbody>
                {/* 4.1 */}
                <tr>
                  <td className="text-center">4.1</td>
                  <td>Address of the proposed building</td>

                  <td>
                    <Field className="form-control mb-2" name="buildingAddressSurveyExisting" placeholder="Survey No." />
                    <ErrorMessage name="buildingAddressSurveyExisting" component="div" className="text-danger small" />

                    {/* <Field className="form-control mb-2" name="buildingAddressDoorExisting" placeholder="Door No." />
                    <ErrorMessage name="buildingAddressDoorExisting" component="div" className="text-danger small" /> */}

                    <Field className="form-control" name="buildingAddressTownExisting" placeholder="Village / Town" />
                    <ErrorMessage name="buildingAddressTownExisting" component="div" className="text-danger small" />
                  </td>

                  <td>
                    <Field className="form-control" name="buildingAddressProposed" />
                    {/* <ErrorMessage name="buildingAddressProposed" component="div" className="text-danger small" /> */}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="buildingAddressRemarks" />
                    <ErrorMessage name="buildingAddressRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.2 */}
                <tr>
                  <td className="text-center">4.2</td>
                  <td>Same Mandal</td>

                  <td className="text-center">
                    <label>
                      <Field
                        type="radio"
                        name="sameMandalExisting"
                        value="Yes"
                        onChange={(e) => {
                          formik.handleChange(e);

                          if (e.target.value === "Yes") {
                            formik.setFieldValue("sameMandalProposed", landDetails?.mandal_name || "");
                          }
                        }}
                      />
                      Yes&nbsp;
                      <Field
                        type="radio"
                        name="sameMandalExisting"
                        value="No"
                        onChange={(e) => {
                          formik.handleChange(e);

                          if (e.target.value === "No") {
                            formik.setFieldValue("sameMandalProposed", "");
                          }
                        }}
                      />
                      No
                    </label>

                    <ErrorMessage name="sameMandalExisting" component="div" className="text-danger small" />
                  </td>

                  <td className="text-center">
                    {formik.values.sameMandalExisting !== "Yes" && <Field className="form-control" name="sameMandalProposed" disabled={isBuildingSameAsExisting} />}
                    {formik.values.sameMandalExisting === "Yes" && landDetails?.mandal_name && <span className="fw-bold">{landDetails.mandal_name}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="sameMandalRemarks" />
                    <ErrorMessage name="sameMandalRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.3 */}
                <tr>
                  <td className="text-center">4.3</td>
                  <td>Permanent RCC Building</td>

                  <td className="text-center">
                    <Field type="radio" name="permanentBuildingExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="permanentBuildingExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="permanentBuildingExisting" component="div" className="text-danger small" />
                  </td>

                  <td className="text-center">
                    <Field className="form-control" name="permanentBuildingProposed" disabled={isBuildingSameAsExisting} />
                    {/* <ErrorMessage name="permanentBuildingProposed" component="div" className="text-danger small" /> */}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="permanentBuildingRemarks" />
                    <ErrorMessage name="permanentBuildingRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.4 */}
                <tr>
                  <td className="text-center">4.4</td>
                  <td>Distance Requirement</td>

                  <td className="text-center">
                    <Field
                      type="radio"
                      name="distanceRequirementExisting"
                      value="Yes"
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (e.target.value === "Yes") {
                          formik.setFieldValue("distanceRequirementProposed", landDetails?.distance || "");
                        }
                      }}
                    />{" "}
                    Yes&nbsp;
                    <Field
                      type="radio"
                      name="distanceRequirementExisting"
                      value="No"
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (e.target.value === "No") {
                          formik.setFieldValue("distanceRequirementProposed", "");
                        }
                      }}
                    />{" "}
                    No&nbsp;
                    <ErrorMessage name="distanceRequirementExisting" component="div" className="text-danger small" />
                  </td>

                  <td className="text-center">
                    {formik.values.distanceRequirementExisting !== "Yes" && <Field className="form-control" name="distanceRequirementProposed" />}
                    {formik.values.distanceRequirementExisting === "Yes" && landDetails?.distance && <span className="fw-bold">{landDetails.distance}</span>}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="distanceRequirementRemarks" />
                    <ErrorMessage name="distanceRequirementRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.5 */}
                <tr>
                  <td className="text-center">4.5</td>
                  <td>Building Ownership</td>

                  <td className="text-center">
                    <label>
                      <input
                        type="radio"
                        name="buildingOwnershipExisting"
                        value="Leased"
                        checked={formik.values.buildingOwnershipExisting === "Leased"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("buildingOwnershipProposed", landDetails?.build_own_lease ? "Own" : "Leased");
                          formik.setFieldValue("saleDeedUploadedExisting", "");
                          // formik.setFieldValue("saleDeedUploadedProposed", "");
                          formik.setFieldValue("saleDeedUploadedRemarks", "");
                          formik.setFieldValue("saleDeedInSocietyExisting", "");
                          // formik.setFieldValue("saleDeedInSocietyProposed", "");
                          formik.setFieldValue("saleDeedInSocietyRemarks", "");
                        }}
                      />{" "}
                      Leased
                    </label>
                    &nbsp;&nbsp;
                    <label>
                      <input
                        type="radio"
                        name="buildingOwnershipExisting"
                        value="Own"
                        checked={formik.values.buildingOwnershipExisting === "Own"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("buildingOwnershipProposed", landDetails?.build_own_lease ? "Own" : "Leased");
                          formik.setFieldValue("leasedDocumentExisting", "");
                          // formik.setFieldValue("leasedDocumentProposed", "");
                          formik.setFieldValue("leasedDocumentRemarks", "");
                          formik.setFieldValue("leaseRegisteredInSocietyExisting", "");
                          // formik.setFieldValue("leaseRegisteredInSocietyProposed", "");
                          formik.setFieldValue("leaseRegisteredInSocietyRemarks", "");
                          formik.setFieldValue("leaseRegistrationYearExisting", "");
                          // formik.setFieldValue("leaseRegistrationYearProposed", "");
                          formik.setFieldValue("leaseRegistrationYearRemarks", "");
                          formik.setFieldValue("leaseValidityFromExisting", "");
                          formik.setFieldValue("leaseValidityToExisting", "");
                          // formik.setFieldValue("leaseValidityFromProposed", "");
                          // formik.setFieldValue("leaseValidityToProposed", "");
                          formik.setFieldValue("leaseValidityRemarks", "");
                          formik.setFieldValue("yearsCompletedExisting", "");
                          // formik.setFieldValue("yearsCompletedProposed", "");
                          formik.setFieldValue("yearsCompletedRemarks", "");
                          formik.setFieldValue("remainingLeaseYearsExisting", "");
                          // formik.setFieldValue("remainingLeaseYearsProposed", "");
                          formik.setFieldValue("remainingLeaseRemarks", "");
                        }}
                      />{" "}
                      Own
                    </label>
                    <ErrorMessage name="buildingOwnershipExisting" component="div" className="text-danger small d-block" />
                  </td>

                  <td className="text-center">
                    <Field className="form-control" name="buildingOwnershipProposed" disabled={isBuildingSameAsExisting} />
                    {/* <ErrorMessage name="buildingOwnershipProposed" component="div" className="text-danger small" /> */}
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="buildingOwnershipRemarks" />
                    <ErrorMessage name="buildingOwnershipRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.6 and subparts conditional */}
                {formik.values.buildingOwnershipExisting === "Leased" && (
                  <>
                    {/* 4.6 */}
                    <tr>
                      <td className="text-center">4.6</td>
                      <td>If leased, Registered lease document of the building is enclosed</td>

                      <td className="text-center">
                        <Field type="radio" name="leasedDocumentExisting" value="Yes" /> Yes&nbsp;
                        <Field type="radio" name="leasedDocumentExisting" value="No" /> No&nbsp;
                        <ErrorMessage name="leasedDocumentExisting" component="div" className="text-danger small" />
                      </td>

                      <td className="text-center">
                        {formik.values.leasedDocumentExisting !== "Yes" && <Field className="form-control" name="leasedDocumentProposed" disabled={isBuildingSameAsExisting} />}
                        {formik.values.leasedDocumentExisting === "Yes" && landDetails?.lease_deed && (
                          <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewImage(landDetails?.lease_deed)}>
                            <FaEye size={20} />
                          </button>
                        )}
                      </td>

                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="leasedDocumentRemarks" />
                        <ErrorMessage name="leasedDocumentRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>

                    {/* 4.6 (a) */}
                    <tr>
                      <td className="text-center">a.</td>
                      <td>Whether the leased document is registered in the name of the society</td>

                      <td className="text-center">
                        <Field
                          type="radio"
                          name="leaseRegisteredInSocietyExisting"
                          value="Yes"
                          onChange={(e) => {
                            formik.handleChange(e);

                            if (e.target.value === "Yes") {
                              formik.setFieldValue("leaseRegisteredInSocietyProposed", landDetails?.society || "");
                            }
                          }}
                        />
                        Yes&nbsp;
                        <Field
                          type="radio"
                          name="leaseRegisteredInSocietyExisting"
                          value="No"
                          onChange={(e) => {
                            formik.handleChange(e);

                            if (e.target.value === "No") {
                              formik.setFieldValue("leaseRegisteredInSocietyProposed", "");
                            }
                          }}
                        />
                        No&nbsp;
                        <ErrorMessage name="leaseRegisteredInSocietyExisting" component="div" className="text-danger small" />
                      </td>

                      <td className="text-center">
                        {formik.values.leaseRegisteredInSocietyExisting !== "Yes" && <Field className="form-control" name="leaseRegisteredInSocietyProposed" disabled={isBuildingSameAsExisting} />}
                        {formik.values.leaseRegisteredInSocietyExisting === "Yes" && landDetails?.society && <span className="fw-bold">{landDetails.society}</span>}
                      </td>

                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="leaseRegisteredInSocietyRemarks" />
                        <ErrorMessage name="leaseRegisteredInSocietyRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>

                    {/* 4.6 (b) */}
                    <tr>
                      <td className="text-center">b.</td>
                      <td>Year of registration of lease document</td>

                      <td>
                        <Field type="date" className="form-control" name="leaseRegistrationYearExisting" />
                        <ErrorMessage name="leaseRegistrationYearExisting" component="div" className="text-danger small" />
                      </td>

                      <td>
                        <Field type="text" className="form-control" name="leaseRegistrationYearProposed" disabled={isBuildingSameAsExisting} />
                        {/* <ErrorMessage name="leaseRegistrationYearProposed" component="div" className="text-danger small" /> */}
                      </td>

                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="leaseRegistrationYearRemarks" />
                        <ErrorMessage name="leaseRegistrationYearRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>

                    {/* 4.6 (c) */}
                    <tr>
                      <td className="text-center">c.</td>
                      <td>Validity of the lease period</td>

                      <td>
                        <Field type="date" className="form-control mb-2" name="leaseValidityFromExisting" />
                        <ErrorMessage name="leaseValidityFromExisting" component="div" className="text-danger small" />
                        <Field type="date" className="form-control" name="leaseValidityToExisting" />

                        <ErrorMessage name="leaseValidityToExisting" component="div" className="text-danger small" />
                      </td>

                      <td>
                        <Field type="text" className="form-control mb-2" name="leaseValidityFromProposed" disabled={isBuildingSameAsExisting} />
                        <ErrorMessage name="leaseValidityFromProposed" component="div" className="text-danger small" />
                        <Field type="text" className="form-control" name="leaseValidityToProposed" disabled={isBuildingSameAsExisting} />

                        {/* <ErrorMessage name="leaseValidityToProposed" component="div" className="text-danger small" /> */}
                      </td>

                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="leaseValidityRemarks" />
                        <ErrorMessage name="leaseValidityRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>

                    {/* 4.6 (d) */}
                    <tr>
                      <td className="text-center">d.</td>
                      <td>Total no. of years completed in leased building from the establishment</td>

                      <td>
                        <Field type="number" className="form-control" name="yearsCompletedExisting" />
                        <ErrorMessage name="yearsCompletedExisting" component="div" className="text-danger small" />
                      </td>

                      <td>
                        <Field type="text" className="form-control" name="yearsCompletedProposed" disabled={isBuildingSameAsExisting} />
                        {/* <ErrorMessage name="yearsCompletedProposed" component="div" className="text-danger small" /> */}
                      </td>

                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="yearsCompletedRemarks" />
                        <ErrorMessage name="yearsCompletedRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>

                    {/* 4.6 (e) */}
                    <tr>
                      <td className="text-center">e.</td>
                      <td>Remaining no. of years of the lease period as on date of application</td>

                      <td>
                        <Field type="number" className="form-control" name="remainingLeaseYearsExisting" />
                        <ErrorMessage name="remainingLeaseYearsExisting" component="div" className="text-danger small" />
                      </td>

                      <td>
                        <Field type="text" className="form-control" name="remainingLeaseYearsProposed" disabled={isBuildingSameAsExisting} />
                        {/* <ErrorMessage name="remainingLeaseYearsProposed" component="div" className="text-danger small" /> */}
                      </td>

                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="remainingLeaseRemarks" />
                        <ErrorMessage name="remainingLeaseRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>
                  </>
                )}

                {/* 4.7 and 4.8 conditional */}
                {formik.values.buildingOwnershipExisting === "Own" && (
                  <>
                    {/* 4.7 */}
                    <tr>
                      <td className="text-center">4.7</td>
                      <td>If own, whether the registered sale deed of the building is uploaded</td>
                      <td className="text-center">
                        <Field type="radio" name="saleDeedUploadedExisting" value="Yes" /> Yes&nbsp;
                        <Field type="radio" name="saleDeedUploadedExisting" value="No" /> No&nbsp;
                        <ErrorMessage name="saleDeedUploadedExisting" component="div" className="text-danger small" />
                      </td>
                      <td className="text-center">
                        {/* {formik.values.saleDeedUploadedExisting === "Yes" ? (
      <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById("saleDeed")}>
        <FaEye size={20} />
      </button>
    ) : ( */}
                        <Field className="form-control" name="saleDeedUploadedProposed" disabled={isBuildingSameAsExisting} />
                        {/* )} */}
                      </td>
                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="saleDeedUploadedRemarks" />
                        <ErrorMessage name="saleDeedUploadedRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>

                    {/* 4.8 */}
                    <tr>
                      <td className="text-center">4.8</td>
                      <td>Whether the sale deed is registered in the name of the Society</td>
                      <td className="text-center">
                        <Field type="radio" name="saleDeedInSocietyExisting" value="Yes" /> Yes&nbsp;
                        <Field type="radio" name="saleDeedInSocietyExisting" value="No" /> No&nbsp;
                        <ErrorMessage name="saleDeedInSocietyExisting" component="div" className="text-danger small" />
                      </td>
                      <td className="text-center">
                        {/* {formik.values.saleDeedInSocietyExisting === "Yes" ? (
      <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById("saleDeedSociety")}>
        <FaEye size={20} />
      </button>
    ) : ( */}
                        <Field className="form-control" name="saleDeedInSocietyProposed" disabled={isBuildingSameAsExisting} />
                        {/* )} */}
                      </td>
                      <td>
                        <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="saleDeedInSocietyRemarks" />
                        <ErrorMessage name="saleDeedInSocietyRemarks" component="div" className="text-danger small" />
                      </td>
                    </tr>
                  </>
                )}

                {/* 4.9 */}
                <tr>
                  <td className="text-center">4.9</td>
                  <td>Whether the plan of the building accommodation is approved by competent authority for running the institution</td>
                  <td className="text-center">
                    <Field type="radio" name="planApprovedExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="planApprovedExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="planApprovedExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    {formik.values.planApprovedExisting === "Yes" ? (
                      hasDocument(4) && (
                        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById(4)}>
                          <FaEye size={20} />
                        </button>
                      )
                    ) : (
                      <Field className="form-control" name="planApprovedProposed" disabled={isBuildingSameAsExisting} />
                    )}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="planApprovedRemarks" />
                    <ErrorMessage name="planApprovedRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.10 */}
                <tr>
                  <td className="text-center">4.10</td>
                  <td>Whether approved plan of the building drawn by licensed surveyor and attested by the Principal of a Government College is uploaded</td>
                  <td className="text-center">
                    <Field type="radio" name="approvedPlanUploadedExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="approvedPlanUploadedExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="approvedPlanUploadedExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    {formik.values.approvedPlanUploadedExisting === "Yes" ? (
                      hasDocument(11) && (
                        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById(11)}>
                          <FaEye size={20} />
                        </button>
                      )
                    ) : (
                      <Field className="form-control" name="approvedPlanUploadedProposed" disabled={isBuildingSameAsExisting} />
                    )}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="approvedPlanUploadedRemarks" />
                    <ErrorMessage name="approvedPlanUploadedRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.11 */}
                <tr>
                  <td className="text-center">4.11</td>
                  <td>Carpet area of the Building (in Sft)</td>
                  <td className="text-center">
                    <Field type="radio" name="carpetAreaExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="carpetAreaExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="carpetAreaExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    <Field className="form-control" name="carpetAreaProposed" disabled={isBuildingSameAsExisting} />
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="carpetAreaRemarks" />
                    <ErrorMessage name="carpetAreaRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.12 */}
                <tr>
                  <td className="text-center">4.12</td>
                  <td>Whether a copy of the construction permission order for the leased / own building issued by competent authority is uploaded</td>
                  <td className="text-center">
                    <Field type="radio" name="constructionPermissionExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="constructionPermissionExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="constructionPermissionExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    {formik.values.constructionPermissionExisting === "Yes" ? (
                      hasDocument(12) && (
                        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById(12)}>
                          <FaEye size={20} />
                        </button>
                      )
                    ) : (
                      <Field className="form-control" name="constructionPermissionProposed" disabled={isBuildingSameAsExisting} />
                    )}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="constructionPermissionRemarks" />
                    <ErrorMessage name="constructionPermissionRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.13 */}
                <tr>
                  <td className="text-center">4.13</td>
                  <td>Whether valid Sanitary Certificate is uploaded</td>
                  <td className="text-center">
                    <Field type="radio" name="sanitaryCertificateExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="sanitaryCertificateExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="sanitaryCertificateExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    {formik.values.sanitaryCertificateExisting === "Yes" ? (
                      hasDocument(15) && (
                        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById(15)}>
                          <FaEye size={20} />
                        </button>
                      )
                    ) : (
                      <Field className="form-control" name="sanitaryCertificateProposed" disabled={isBuildingSameAsExisting} />
                    )}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="sanitaryCertificateRemarks" />
                    <ErrorMessage name="sanitaryCertificateRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.14 */}
                <tr>
                  <td className="text-center">4.14</td>
                  <td>Whether latest Geotagged photographs of the building attested by the Principal of a Government College are uploaded</td>
                  <td className="text-center">
                    <Field type="radio" name="geoTaggedPhotosExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="geoTaggedPhotosExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="geoTaggedPhotosExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    {formik.values.geoTaggedPhotosExisting === "Yes" ? (
                      hasDocument(16) && (
                        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById(16)}>
                          <FaEye size={20} />
                        </button>
                      )
                    ) : (
                      <Field className="form-control" name="geoTaggedPhotosProposed" disabled={isBuildingSameAsExisting} />
                    )}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="geoTaggedPhotosRemarks" />
                    <ErrorMessage name="geoTaggedPhotosRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.15 */}
                <tr>
                  <td className="text-center">4.15</td>
                  <td>Whether any other Institution is running in the same building accommodation</td>
                  <td className="text-center">
                    <label>
                      <input type="radio" name="otherInstitutionExisting" value="Yes" checked={formik.values.otherInstitutionExisting === "Yes"} onChange={formik.handleChange} /> Yes
                    </label>
                    &nbsp;
                    <label>
                      <input
                        type="radio"
                        name="otherInstitutionExisting"
                        value="No"
                        checked={formik.values.otherInstitutionExisting === "No"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("otherInstitutionProposed", "");
                          formik.setFieldValue("nocUploadedExisting", "");
                          formik.setFieldValue("nocUploadedProposed", "");
                          formik.setFieldValue("nocUploadedRemarks", "");
                        }}
                      />{" "}
                      No
                    </label>
                    <ErrorMessage name="otherInstitutionExisting" component="div" className="text-danger small d-block" />
                  </td>
                  <td className="text-center">
                    {formik.values.otherInstitutionExisting === "Yes" && <Field className="form-control" name="otherInstitutionProposed" disabled={isBuildingSameAsExisting} />}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="otherInstitutionRemarks" />
                    <ErrorMessage name="otherInstitutionRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>

                {/* 4.16 — ✅ Only show if 4.15 = "Yes" */}
                {formik.values.otherInstitutionExisting === "Yes" && (
                  <tr>
                    <td className="text-center">4.16</td>
                    <td>
                      If yes, whether NoC from the concerned authority to utilize part of the building, which is not being utilized by the other institution, for running this institution is uploaded
                    </td>
                    <td className="text-center">
                      <Field type="radio" name="nocUploadedExisting" value="Yes" /> Yes&nbsp;
                      <Field type="radio" name="nocUploadedExisting" value="No" /> No&nbsp;
                      <ErrorMessage name="nocUploadedExisting" component="div" className="text-danger small" />
                    </td>
                    <td className="text-center">
                      {/* {formik.values.nocUploadedExisting === "Yes" ? (
        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById("noc")}>
          <FaEye size={20} />
        </button>
      ) : ( */}
                      <Field className="form-control" name="nocUploadedProposed" disabled={isBuildingSameAsExisting} />
                      {/* )} */}
                    </td>
                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="nocUploadedRemarks" />
                      <ErrorMessage name="nocUploadedRemarks" component="div" className="text-danger small" />
                    </td>
                  </tr>
                )}

                {/* 4.17 */}
                <tr>
                  <td className="text-center">4.17</td>
                  <td>Whether the details of existing building accommodation provided in Annexure-I are in accordance with the stipulated norms</td>
                  <td className="text-center">
                    <Field type="radio" name="annexureDetailsExisting" value="Yes" /> Yes&nbsp;
                    <Field type="radio" name="annexureDetailsExisting" value="No" /> No&nbsp;
                    <ErrorMessage name="annexureDetailsExisting" component="div" className="text-danger small" />
                  </td>
                  <td className="text-center">
                    {formik.values.annexureDetailsExisting === "Yes" ? (
                      hasDocument(26) && (
                        <button type="button" className="btn btn-link p-0 text-primary mt-1" onClick={() => viewDocumentById(26)}>
                          <FaEye size={20} />
                        </button>
                      )
                    ) : (
                      <Field className="form-control" name="annexureDetailsProposed" disabled={isBuildingSameAsExisting} />
                    )}
                  </td>
                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="annexureDetailsRemarks" />
                    <ErrorMessage name="annexureDetailsRemarks" component="div" className="text-danger small" />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* UG Accommodation */}
        {getAccomidation?.length > 0 && (
          <>
            <React.Fragment key={getAccomidation.length}>
              <h5 className="text-success mb-3">4.18. Accommodation Details</h5>

              <Table bordered responsive>
                <thead className="table-primary text-center">
                  <tr>
                    <th>Sl. No.</th>
                    <th>Type of the room</th>
                    <th>No. of room(s) required</th>
                    <th>Total carpet area (sft) required</th>
                    <th>No. of room(s) provided</th>
                    <th>Total carpet area (sft) provided</th>
                    <th>Whether sufficient as per norms</th>
                    <th>Remarks</th>
                  </tr>
                </thead>

                <tbody>
                  {getAccomidation.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{item.particular_name}</td>
                      <td>{item.no_of_rooms}</td>
                      <td>{item.total_area}</td>
                      <td>{item.no_of_rooms}</td>
                      <td>{item.total_area}</td>

                      {/* Radio */}
                      <td>
                        <label>
                          <input
                            type="radio"
                            name={`accomodation.${index}.sufficientAsPerNorms`}
                            value="Yes"
                            checked={formik.values.accomodation?.[index]?.sufficientAsPerNorms === "Yes"}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          Yes
                        </label>
                        <label className="ms-2">
                          <input
                            type="radio"
                            name={`accomodation.${index}.sufficientAsPerNorms`}
                            value="No"
                            checked={formik.values.accomodation?.[index]?.sufficientAsPerNorms === "No"}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          No
                        </label>
                        {formik.touched.accomodation?.[index]?.sufficientAsPerNorms && formik.errors.accomodation?.[index]?.sufficientAsPerNorms && (
                          <div className="text-danger small mt-1">{formik.errors.accomodation[index].sufficientAsPerNorms}</div>
                        )}
                      </td>

                      {/* Remarks */}
                      <td>
                        <textarea
                          rows="3"
                          style={textareaStyle}
                          placeholder="Remarks"
                          className="form-control"
                          name={`accomodation.${index}.remarks`}
                          value={formik.values.accomodation?.[index]?.remarks || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.accomodation?.[index]?.remarks && formik.errors.accomodation?.[index]?.remarks && (
                          <div className="text-danger small mt-1">{formik.errors.accomodation[index].remarks}</div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </React.Fragment>
          </>
        )}
        <Row>
          <Col>
            <Table bordered responsive className="scrutiny-report-table">
              {/* Table Header */}
              <thead className="table-primary text-center">
                <tr>
                  <th style={{ width: "5%" }}>Sl.No</th>
                  <th style={{ width: "50%" }}>Description</th>
                  <th style={{ width: "15%" }}>Yes / No</th>
                  <th style={{ width: "25%" }}>Remarks</th>
                </tr>
              </thead>

              <tbody>
                {/* 4.21 PARKING AREA */}
                <tr style={{ background: "#f9f9f9" }}>
                  <td className="text-center" style={{ fontWeight: "bold" }}>
                    4.19
                  </td>

                  <td colSpan="3" style={{ fontWeight: "bold" }}>
                    Parking area
                  </td>
                </tr>

                {/* a */}
                <tr>
                  <td className="text-center">a.</td>

                  <td>Whether the parking area is available in the same premises</td>

                  <td style={{ textAlign: "center" }}>
                    <label>
                      <input
                        type="radio"
                        name="parkingAreaSamePremisesExisting"
                        value="Yes"
                        checked={formik.values.parkingAreaSamePremisesExisting === "Yes"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("parkingAreaWithin100mExisting", "");
                          formik.setFieldValue("parkingAreaWithin100mRemarks", "");
                          formik.setFieldValue("parkingAreaWithin100mDocUploaded", "");
                          formik.setFieldValue("parkingAreaWithin100mDocRemarks", "");
                        }}
                      />{" "}
                      Yes
                    </label>
                    &nbsp;&nbsp;
                    <label>
                      <input
                        type="radio"
                        name="parkingAreaSamePremisesExisting"
                        value="No"
                        checked={formik.values.parkingAreaSamePremisesExisting === "No"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("parkingArea20PercentExisting", "");
                          formik.setFieldValue("parkingArea20PercentRemarks", "");
                        }}
                      />{" "}
                      No
                    </label>
                    <ErrorMessage name="parkingAreaSamePremisesExisting" component="div" className="text-danger" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="parkingAreaSamePremisesRemarks" />
                    <ErrorMessage name="parkingAreaSamePremisesRemarks" component="div" className="text-danger" />
                  </td>
                </tr>

                {/* a.1 */}
                {formik.values.parkingAreaSamePremisesExisting === "No" && (
                  <tr>
                    <td className="text-center">a.1</td>
                    <td>If not in the same premises, whether the parking area provided within a distance of 100 meters thereof</td>
                    <td style={{ textAlign: "center" }}>
                      <label>
                        <input
                          type="radio"
                          name="parkingAreaWithin100mExisting"
                          value="Yes"
                          checked={formik.values.parkingAreaWithin100mExisting === "Yes"}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />{" "}
                        Yes
                      </label>
                      &nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          name="parkingAreaWithin100mExisting"
                          value="No"
                          checked={formik.values.parkingAreaWithin100mExisting === "No"}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.setFieldValue("parkingAreaWithin100mDocUploaded", "");
                            formik.setFieldValue("parkingAreaWithin100mDocRemarks", "");
                          }}
                        />{" "}
                        No
                      </label>
                      <ErrorMessage name="parkingAreaWithin100mExisting" component="div" className="text-danger" />
                    </td>
                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="parkingAreaWithin100mRemarks" />
                      <ErrorMessage name="parkingAreaWithin100mRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* a.2 */}
                {formik.values.parkingAreaSamePremisesExisting === "No" && formik.values.parkingAreaWithin100mExisting === "Yes" && (
                  <tr>
                    <td className="text-center">a.2</td>
                    <td>Whether the document is uploaded for proof of parking area with in 100 meters</td>
                    <td style={{ textAlign: "center" }}>
                      <label>
                        <Field type="radio" name="parkingAreaWithin100mDocUploaded" value="Yes" /> Yes
                      </label>
                      <label className="ms-3">
                        <Field type="radio" name="parkingAreaWithin100mDocUploaded" value="No" /> No
                      </label>
                      <ErrorMessage name="parkingAreaWithin100mDocUploaded" component="div" className="text-danger" />
                    </td>
                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="parkingAreaWithin100mDocRemarks" />
                      <ErrorMessage name="parkingAreaWithin100mDocRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* b */}
                {formik.values.parkingAreaSamePremisesExisting === "Yes" && (
                  <tr>
                    <td className="text-center">b.</td>

                    <td>Whether 20% of the total built up area is provided for the Parking area</td>

                    <td style={{ textAlign: "center" }}>
                      <Field type="radio" name="parkingArea20PercentExisting" value="Yes" /> Yes &nbsp;&nbsp;
                      <Field type="radio" name="parkingArea20PercentExisting" value="No" /> No
                      <ErrorMessage name="parkingArea20PercentExisting" component="div" className="text-danger" />
                    </td>

                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="parkingArea20PercentRemarks" />
                      <ErrorMessage name="parkingArea20PercentRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* 4.22 PLAYGROUND */}
                <tr style={{ background: "#f9f9f9" }}>
                  <td className="text-center" style={{ fontWeight: "bold" }}>
                    4.20
                  </td>

                  <td colSpan="3" style={{ fontWeight: "bold" }}>
                    Playground
                  </td>
                </tr>

                {/* a */}
                <tr>
                  <td className="text-center">a.</td>

                  <td>Whether the Playground facility is available in the same premises</td>

                  <td style={{ textAlign: "center" }}>
                    <label>
                      <input
                        type="radio"
                        name="playgroundSamePremisesExisting"
                        value="Yes"
                        checked={formik.values.playgroundSamePremisesExisting === "Yes"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("playgroundAlternativeExisting", "");
                          formik.setFieldValue("playgroundAlternativeRemarks", "");
                        }}
                      />{" "}
                      Yes
                    </label>
                    &nbsp;&nbsp;
                    <label>
                      <input
                        type="radio"
                        name="playgroundSamePremisesExisting"
                        value="No"
                        checked={formik.values.playgroundSamePremisesExisting === "No"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik.setFieldValue("playgroundExtentExisting", "");
                          formik.setFieldValue("playgroundExtentRemarks", "");
                          formik.setFieldValue("playgroundMouExisting", "");
                          formik.setFieldValue("playgroundMouRemarks", "");
                        }}
                      />{" "}
                      No
                    </label>
                    <ErrorMessage name="playgroundSamePremisesExisting" component="div" className="text-danger" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="playgroundSamePremisesRemarks" />

                    <ErrorMessage name="playgroundSamePremisesRemarks" component="div" className="text-danger" />
                  </td>
                </tr>

                {/* b */}
                {formik.values.playgroundSamePremisesExisting === "Yes" && (
                  <tr>
                    <td className="text-center">b.</td>
                    <td>If yes, mention the extent of the playground facility available (sft)</td>
                    <td>
                      <Field className="form-control" name="playgroundExtentExisting" />
                      <ErrorMessage name="playgroundExtentExisting" component="div" className="text-danger" />
                    </td>
                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="playgroundExtentRemarks" />
                      <ErrorMessage name="playgroundExtentRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* c */}
                {formik.values.playgroundSamePremisesExisting === "No" && (
                  <tr>
                    <td className="text-center">c.</td>

                    <td>If not, whether any alternative arrangement for playground is provided within a radius of 5 kms along with bus facility</td>

                    <td style={{ textAlign: "center" }}>
                      <Field type="radio" name="playgroundAlternativeExisting" value="Yes" /> Yes &nbsp;&nbsp;
                      <Field type="radio" name="playgroundAlternativeExisting" value="No" /> No
                      <ErrorMessage name="playgroundAlternativeExisting" component="div" className="text-danger" />
                    </td>

                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="playgroundAlternativeRemarks" />
                      <ErrorMessage name="playgroundAlternativeRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* d */}
                {formik.values.playgroundSamePremisesExisting === "Yes" && (
                  <tr>
                    <td className="text-center">d.</td>

                    <td>If yes, whether MoU for utilization of the alternative facility for playground is produced</td>

                    <td style={{ textAlign: "center" }}>
                      <Field type="radio" name="playgroundMouExisting" value="Yes" /> Yes &nbsp;&nbsp;
                      <Field type="radio" name="playgroundMouExisting" value="No" /> No
                      <ErrorMessage name="playgroundMouExisting" component="div" className="text-danger" />
                    </td>

                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="playgroundMouRemarks" />
                      <ErrorMessage name="playgroundMouRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* 4.23 FIRE SAFETY */}
                <tr>
                  <td className="text-center" style={{ fontWeight: "bold" }}>
                    4.21
                  </td>

                  <td style={{ fontWeight: "bold" }}>Whether valid fire safety certificate / latest affidavit for exempted cases is produced</td>

                  <td style={{ textAlign: "center" }}>
                    <Field type="radio" name="fireSafetyCertificateExisting" value="Yes" /> Yes &nbsp;&nbsp;
                    <Field type="radio" name="fireSafetyCertificateExisting" value="No" /> No
                    <ErrorMessage name="fireSafetyCertificateExisting" component="div" className="text-danger" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="fireSafetyCertificateRemarks" />
                    <ErrorMessage name="fireSafetyCertificateRemarks" component="div" className="text-danger" />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        {/******* UG Programmes Details ************/}
        {getUgCourses?.length > 0 && (
          <>
            <h5 className="text-success mb-3">5.Details of the UG programmes</h5>

            <Table bordered responsive>
              <thead className="table-primary text-center">
                <tr>
                  <th>Sl. No.</th>
                  <th>Type of the UG Programme</th>
                  <th>Total No. of programmes</th>
                  <th>Sanctioned Intake</th>
                </tr>
              </thead>

              <tbody>
                {getUgCourses.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>{item.course_cat_name || "-"}</td>
                    <td className="text-center">{item.count ?? "-"}</td>
                    <td className="text-center">{item.sum ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {/* ***********Pg Programmes Details************ */}
        {Array.isArray(pgCourses) && pgCourses.length > 0 && (
          <>
            <h5 className="text-success mb-3">Details of the PG programmes</h5>
            <Table bordered responsive>
              <thead className="table-primary text-center">
                <tr>
                  <th>Sl. No.</th>
                  <th>Type of the PG Programme</th>
                  <th>Total No. of programmes</th>
                  <th>Sanctioned Intake</th>
                </tr>
              </thead>
              <tbody>
                {/* {pgCourses?.map((item, index) => ( */}
                {Array.isArray(pgCourses) &&
                  pgCourses.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{item.course_cat_name}</td>
                      <td className="text-center">{item.count}</td>
                      <td className="text-center">{item.sum}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </>
        )}

        {/*************  Corpus Fund Section **********/}
        <h5 className="text-success mb-3">7.Corpus Fund</h5>
        <table className="table table-bordered">
          <thead className="table-primary text-center">
            <tr>
              <th style={{ width: "5%" }}>Sl.No</th>
              <th style={{ width: "65%" }}>Particulars</th>
              <th style={{ width: "30%" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">a.</td>
              <td>Whether the college was exempted from paying the Corpus Fund:</td>

              <td>
                <label>
                  <input type="radio" name="corpusFund" value="Yes" onChange={formik.handleChange} checked={formik.values.corpusFund === "Yes"} /> Yes
                </label>
                <label className="ms-3">
                  <input
                    type="radio"
                    name="corpusFund"
                    value="No"
                    onChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("certificateIssued", "");
                    }}
                    checked={formik.values.corpusFund === "No"}
                  />{" "}
                  No
                </label>
                <ErrorMessage name="corpusFund" component="div" className="text-danger d-block" />
              </td>
            </tr>
            {formik.values.corpusFund === "Yes" && (
              <tr>
                <td className="text-center">b.</td>

                <td>whether the rural/tribal area certificate issued by MRO is produced:</td>

                <td>
                  <input
                    type="radio"
                    name="certificateIssued"
                    value="Yes"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.certificateIssued === "Yes"}
                  // disabled={isDisabled}
                  />{" "}
                  Yes
                  <input
                    type="radio"
                    name="certificateIssued"
                    value="No"
                    className="ms-3"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.certificateIssued === "No"}
                  // disabled={isDisabled}
                  />{" "}
                  No
                  <ErrorMessage name="certificateIssued" component="div" className="text-danger" />
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {formik.values.corpusFund === "No" && (
          <>
            {/* For Degree Colleges established before 2021-22 - Using corpusFundInstall data */}
            {corpusFundInstall.length > 0 && (
              <>
                <h5 className="text-success mb-3">For Degree Colleges established before 2021-22</h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th rowSpan={2}>Required Information</th>
                      <th colSpan={3}>Installments</th>
                    </tr>
                    <tr>
                      <th>First</th>
                      <th>Second</th>
                      <th>Third</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Amount</td>
                      <td>{firstInstallment.amount || "-"}</td>
                      <td>{secondInstallment.amount || "-"}</td>
                      <td>{thirdInstallment.amount || "-"}</td>
                    </tr>
                    <tr>
                      <td>Period (from - to)</td>
                      <td>{firstInstallment.from_date ? `${firstInstallment.from_date} - ${firstInstallment.to_date}` : "-"}</td>
                      <td>{secondInstallment.from_date ? `${secondInstallment.from_date} - ${secondInstallment.to_date}` : "-"}</td>
                      <td>{thirdInstallment.from_date ? `${thirdInstallment.from_date} - ${thirdInstallment.to_date}` : "-"}</td>
                    </tr>
                    <tr>
                      <td>Date of FDR</td>
                      <td>{firstInstallment.date_of_fdr || "-"}</td>
                      <td>{secondInstallment.date_of_fdr || "-"}</td>
                      <td>{thirdInstallment.date_of_fdr || "-"}</td>
                    </tr>
                    <tr>
                      <td>Name & address of the Issuing Bank</td>
                      <td>{firstInstallment.bank_address || "-"}</td>
                      <td>{secondInstallment.bank_address || "-"}</td>
                      <td>{thirdInstallment.bank_address || "-"}</td>
                    </tr>
                    <tr>
                      <td>IFSC CODE</td>
                      <td>{firstInstallment.ifsc || "-"}</td>
                      <td>{secondInstallment.ifsc || "-"}</td>
                      <td>{thirdInstallment.ifsc || "-"}</td>
                    </tr>
                    <tr>
                      <td>Date of maturity</td>
                      <td>{firstInstallment.date_of_maturity || "-"}</td>
                      <td>{secondInstallment.date_of_maturity || "-"}</td>
                      <td>{thirdInstallment.date_of_maturity || "-"}</td>
                    </tr>
                    <tr>
                      <td>Date of renewal</td>
                      <td>{firstInstallment.date_of_renewal || "-"}</td>
                      <td>{secondInstallment.date_of_renewal || "-"}</td>
                      <td>{thirdInstallment.date_of_renewal || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}

            {/* For Degree Colleges / programmes sanctioned after 2021-22 - Using ugCorpusFunds data */}
            {ugCorpusFunds.length > 0 && (
              <>
                <h5 className="text-success mb-3">For Degree Colleges / programmes sanctioned after 2021-22</h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Programme</th>
                      <th>Amount</th>
                      <th>Period (from - to)</th>
                      <th>FDR / Bank Guarantee No.</th>
                      <th>Date</th>
                      <th>Name & address of the Issuing Bank (with IFSC code)</th>
                      <th>Date of maturity</th>
                      <th>Date of renewal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ugCorpusFunds.map((item, index) => (
                      <tr key={item.sno || index}>
                        <td className="text-center">{index + 1}</td>
                        <td>{item.course_name || "-"}</td>
                        <td>{item.amount || "-"}</td>
                        <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>
                        <td>{item.fdr_bank_number || "-"}</td>
                        <td>{item.corpus_date || "-"}</td>
                        <td>{item.bank_address && item.ifsc ? `${item.bank_address} (${item.ifsc})` : item.bank_address || item.ifsc || "-"}</td>
                        <td>{item.date_maturity || "-"}</td>
                        <td>{item.date_renewal || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}

            {/* For existing PG Programmes sanctioned before 2021-22 */}
            {pgBefore.length > 0 && (
              <>
                <h5 className="text-success mb-3">For existing PG Programmes sanctioned before 2021-22</h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Programme</th>
                      <th>Amount</th>
                      <th>Period (from - to)</th>
                      <th>FDR / Bank Guarantee No.</th>
                      <th>Date</th>
                      <th>Name & address of the Issuing Bank (with IFSC code)</th>
                      <th>Date of maturity</th>
                      <th>Date of renewal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pgBefore.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>

                        <td>{item.course_name || "-"}</td>
                        <td>{item.amount || "-"}</td>

                        <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>

                        <td>{item.fdr_bank_number || "-"}</td>
                        <td>{item.corpus_date || "-"}</td>

                        <td>{item.bank_address ? `${item.bank_address} (${item.ifsc || "-"})` : "-"}</td>

                        <td>{item.date_maturity || "-"}</td>
                        <td>{item.date_renewal || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}

            {/* For existing PG Programmes sanctioned after 2021-22 - Using pgCorpusFunds data */}
            {pgCorpusFunds.length > 0 && (
              <>
                <h5 className="text-success mb-3">For existing PG Programmes sanctioned after 2021-22</h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Programme</th>
                      <th>Amount</th>
                      <th>Period (from - to)</th>
                      <th>FDR / Bank Guarantee No.</th>
                      <th>Date</th>
                      <th>Name & address of the Issuing Bank (with IFSC code)</th>
                      <th>Date of maturity</th>
                      <th>Date of renewal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pgCorpusFunds.map((item, index) => (
                      <tr key={item.sno || index}>
                        <td className="text-center">{index + 1}</td>
                        <td>{item.course_name || "-"}</td>
                        <td>{item.amount || "-"}</td>
                        <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>
                        <td>{item.fdr_bank_number || "-"}</td>
                        <td>{item.corpus_date || "-"}</td>
                        <td>{item.bank_address && item.ifsc ? `${item.bank_address} (${item.ifsc})` : item.bank_address || item.ifsc || "-"}</td>
                        <td>{item.date_maturity || "-"}</td>
                        <td>{item.date_renewal || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </>
        )}

        <Row className="mt-4">
          <Col>
            <h5 className="text-success mb-3">8. Staff particulars</h5>

            <Table bordered responsive className="scrutiny-report-table">
              <thead className="table-primary text-center">
                <tr>
                  <th style={{ width: "5%" }}>Sl.No</th>
                  <th style={{ width: "50%" }}>Particulars</th>
                  <th style={{ width: "15%" }}>Action</th>
                  <th style={{ width: "25%" }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {/* a */}
                <tr>
                  <td className="text-center">a</td>

                  <td>Whether adequate teaching and supporting staff are provided to run the colleges as per the University / UGC norms</td>

                  <td style={{ textAlign: "center" }}>
                    <div>
                      <label>
                        <input
                          type="radio"
                          name="staffAdequate"
                          value="Yes"
                          checked={formik.values.staffAdequate === "Yes"}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.setFieldValue("staffDeficiencies", "");
                            formik.setFieldValue("staffDeficienciesRemarks", "");
                          }}
                        />{" "}
                        Yes
                      </label>
                      &nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          name="staffAdequate"
                          value="No"
                          checked={formik.values.staffAdequate === "No"}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />{" "}
                        No
                      </label>
                    </div>

                    <ErrorMessage name="staffAdequate" component="div" className="text-danger" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="staffAdequateRemarks" />
                    <ErrorMessage name="staffAdequateRemarks" component="div" className="text-danger" />
                  </td>
                </tr>

                {/* b */}
                {formik.values.staffAdequate === "No" && (
                  <tr>
                    <td className="text-center">b</td>
                    <td>If no, mention the deficiencies</td>
                    <td>
                      <Field className="form-control" name="staffDeficiencies" />
                      <ErrorMessage name="staffDeficiencies" component="div" className="text-danger" />
                    </td>
                    <td>
                      <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="staffDeficienciesRemarks" />
                      <ErrorMessage name="staffDeficienciesRemarks" component="div" className="text-danger" />
                    </td>
                  </tr>
                )}

                {/* c */}
                <tr>
                  <td className="text-center">c</td>
                  <td>Whether undertaking on Rs. 100 non-judicial bond paper is submitted by both the societies</td>
                  <td>
                    <Field className="form-control" name="undertakingBondSubmitted" />
                    <ErrorMessage name="undertakingBondSubmitted" component="div" className="text-danger" />
                  </td>

                  <td>
                    <Field as="textarea" rows="3" style={textareaStyle} placeholder="Remarks" className="form-control" name="undertakingBondRemarks" />
                    <ErrorMessage name="undertakingBondRemarks" component="div" className="text-danger" />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <h5 className="text-success mb-3">Final Remarks</h5>

            <div className="mb-3">
              <Field
                as="textarea"
                name="finalRemarks"
                className="form-control"
                rows="5"
                style={{
                  height: "auto",
                  resize: "vertical",
                }}
                placeholder="Enter final remarks..."
              />

              <ErrorMessage name="finalRemarks" component="div" className="text-danger mt-1" />
            </div>
          </Col>
        </Row>

        <Row className="mt-3 mb-4">
          <Col md={6}>
            <h5 className="text-success mb-3">Final Status</h5>

            <Field as="select" name="finalStatus" className="form-control" value={selectedFinalStatus || formik.values.finalStatus} onChange={handleFinalStatusChange} onBlur={formik.handleBlur}>
              <option value="">-- Select Status --</option>
              <option value="DeficiencyIdentified">Deficiencies Found</option>
              <option value="NoDeficienciesIdentified">No Deficiencies</option>
            </Field>

            <ErrorMessage name="finalStatus" component="div" className="text-danger mt-1" />
          </Col>
        </Row>

        {showDeficienciesSection && (
          <Row className="mt-4">
            <Col>
              <h5 className="text-success mb-3">Deficiencies Found</h5>

              <Table bordered responsive className="deficiency-table">
                <thead className="table-primary text-center">
                  <tr>
                    <th style={{ width: "8%" }}>S.No</th>
                    <th style={{ width: "75%" }}>Deficiency Identified</th>
                    <th style={{ width: "17%" }}>Action</th>
                  </tr>
                </thead>

                <FieldArray name="deficiencies">
                  {({ insert, remove, push }) => (
                    <tbody>
                      {formik.values.deficiencies &&
                        formik.values.deficiencies.length > 0 &&
                        formik.values.deficiencies.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>

                            <td>
                              <Field
                                as="textarea"
                                rows="3"
                                style={textareaStyle}
                                className="form-control"
                                name={`deficiencies[${index}].deficiences`}
                                placeholder="Enter deficiency details..."
                              />
                              <ErrorMessage name={`deficiencies[${index}].deficiences`} component="div" className="text-danger small mt-1" />
                            </td>

                            <td className="text-center">
                              {formik.values.deficiencies.length > 1 && (
                                <button type="button" className="btn btn-link text-danger p-0" onClick={() => remove(index)} title="Delete this row">
                                  <BiTrash size={20} />
                                </button>
                              )}

                              {index === formik.values.deficiencies.length - 1 && (
                                <button type="button" className="btn btn-link text-success p-0 ms-2" onClick={() => push({ id: formik.values.deficiencies.length + 1, deficiences: "" })}>
                                  <VscDiffAdded size={20} />
                                  Add
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  )}
                </FieldArray>
              </Table>
            </Col>
          </Row>
        )}
        <div className="mt-3" style={{ textAlign: "right" }}>
          {!finalsubmit ? (
            <>
              <button type="button" className="btn btn-secondary me-2" onClick={handleSave}>
                Save
              </button>

              <button
                type="button"
                className="btn btn-success"
                onClick={handleFinalSubmit}
              >
                Final Submit
              </button>

            </>
          ) : (
            <>
              <div className="d-flex justify-content-end mt-3 align-items-center">
                <span className="text-success me-3">✅ Already Submitted</span>

                {(selectedFinalStatus === "DeficiencyIdentified") && (
                  <button type="button" className="btn btn-primary" onClick={handleDownloadManagementPDF}>
                    📄 Download Deficiencies PDF
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </Form>
    </FormikProvider >
  );
}
